// data/destinationsData.js

const destinations = [
  {
    id: 1,
    name: "Australia",
    image: "/country/Australia/australia1.jpg",
    rating: 4.8,
    days: 10,
    categories: ["Adventure"],
    months: ["January", "October", "February", "March"],
    title: "Experience the Untamed Beauty of Australia – Book Your Journey Today",
    description: `
      Australia is a land of stunning contrasts and unforgettable experiences. From sun-soaked beaches and vibrant coral reefs to ancient rainforests and iconic landmarks, the country offers something for every type of traveler. Whether you're seeking adventure in the Outback, urban exploration in Sydney, or coastal serenity along the Great Ocean Road, Australia delivers with breathtaking scenery and warm hospitality.
      
      With its rich Indigenous heritage, unique wildlife, and dynamic cities, Australia is not just a destination—it's a journey into one of the world's most diverse environments. You'll find vibrant food scenes, friendly locals, and the kind of natural wonders that leave you speechless. Every state has its own charm, making multi-stop trips exciting and fulfilling.
    `,
    gallery: [
      "/country/Australia/australia1.jpg",
      "/country/Australia/australia2.jpg",
      "/country/Australia/australia8.jpg",
      "/country/Australia/australia3.jpg",
      "/country/Australia/australia4.jpg",
      "/country/Australia/australia5.jpg",
      "/country/Australia/australia6.jpg",
      "/country/Australia/australia7.jpg",
      "/country/Australia/australia9.png",
    ],
    highlights: [
      "Snorkel or dive at the Great Barrier Reef, the largest living organism on Earth",
      "Catch the sunrise over Uluru in the Northern Territory",
      "Enjoy panoramic views from the Sydney Tower Eye",
      "Experience Aboriginal storytelling and bush tucker tours",
      "Explore the wildlife-rich Daintree Rainforest",
      "Drive along the dramatic coastline of the Great Ocean Road",
      "Surf at Bondi Beach or learn to paddleboard in Noosa",
      "Taste award-winning wines in the Barossa Valley and Margaret River"
    ],
    basicInfo: {
      "Destination": "Australia",
      "Entry Point": "Sydney / Melbourne / Brisbane International Airport",
      "Official Language": "English",
      "Currency": "Australian Dollar (AUD)",
      "Visa Requirement": "eVisitor or ETA (Electronic Travel Authority) required prior to arrival",
      "Best Travel Time": "October to March (Spring/Summer)",
      "Travel Group Size": "Small groups (2-12 people)",
      "Time Zone": "GMT+10 (varies by region)"
    },
    included: [
      "4-star and 5-star hotel accommodations",
      "Daily breakfast and select dinners",
      "Airport pick-up and drop-off",
      "Guided city and nature tours",
      "Entrance fees to national parks",
      "Travel insurance (basic coverage)",
      "Domestic flight for internal travel (if part of itinerary)"
    ],
    tips: [
      "Tap water is drinkable and widely available.",
      "Most shops close early in smaller towns — plan ahead.",
      "Avoid touching or feeding wild animals — even kangaroos.",
      "Use reef-safe sunscreen when swimming in the ocean.",
      "Driving is on the left side — familiarize yourself before renting a car.",
      "Weather can vary — pack both summer and light winter clothing."
    ]
  },
  
  {
    id: 2,
    name: "Maldives",
    image: "/images/destinations/maldives.jpg",
    rating: 4.8,
    days: 7,
    categories: ["Beaches"],
    months: ["January"],
    description: `
      The Maldives is a stunning archipelago of over 1,000 coral islands, famed for its crystal-clear turquoise waters, white-sand beaches, and luxurious overwater bungalows. A favorite among honeymooners and beach lovers, the Maldives offers a peaceful escape with a perfect blend of seclusion and indulgence.
  
      From private water villas suspended over the ocean to world-renowned scuba diving spots teeming with marine life, this tropical paradise is tailor-made for relaxation and adventure alike. Sunsets here are breathtaking, spa experiences are world-class, and the pace of life is blissfully slow.
  
      Whether you're sipping cocktails on a deck, dining under the stars, or snorkeling with manta rays and turtles, the Maldives promises memories that last a lifetime.
    `,
    highlights: [
      "Crystal-clear beaches",
      "Private water villas",
      "Best scuba diving spots"
    ],
    gallery: [
      "/country/Maldives/maldives1.jpg",
      "/country/Maldives/maldives2.jpg",
      "/country/Maldives/maldives3.jpg",
      "/country/Maldives/maldives4.jpg",
      "/country/Maldives/maldives5.jpg",
      "/country/Maldives/maldives6.jpg",
      "/country/Maldives/maldives7.jpg",
    ],
    basicInfo: {
      "Destination": "Maldives",
      "Entry Point": "Velana International Airport, Malé",
      "Official Language": "Dhivehi (English widely spoken)",
      "Currency": "Maldivian Rufiyaa (MVR)",
      "Visa Requirement": "30-day visa on arrival for most nationalities",
      "Best Travel Time": "December to April (dry season)",
      "Travel Group Size": "Ideal for couples or small private groups",
      "Time Zone": "GMT+5"
    },
    included: [
      "Luxury resort accommodations",
      "Daily breakfast and dinner buffets",
      "Airport speedboat or seaplane transfers",
      "Snorkeling equipment and reef access",
      "Sunset cruise experience",
      "24/7 resort concierge service"
    ],
    tips: [
      "Pack reef-safe sunscreen to protect marine life.",
      "Wi-Fi is widely available but may be slower on remote islands.",
      "Tipping is not mandatory but appreciated.",
      "Dress modestly when visiting Malé or local islands.",
      "Many resorts operate on their own islands – confirm transfer options in advance."
    ],
    title: "Escape to Paradise – Your Dream Maldives Getaway Starts Here"
  },  
    
  {
    id: 3,
    name: "Thailand",
    image: "/images/destinations/thailand.jpg",
    rating: 4.8,
    days: 7,
    categories: ["Beaches", "Adventure"],
    months: ["January", "November"],
    title: "Uncover the Spirit of Thailand – Temples, Tropics & Timeless Culture",
    description: `
      Thailand is a vibrant Southeast Asian destination known for its golden temples, pristine beaches, lively markets, and rich cultural heritage. From the spiritual calm of Chiang Mai to the buzzing energy of Bangkok and the tropical bliss of Phuket and Krabi, Thailand offers experiences for every kind of traveler.
  
      Whether you're exploring ancient ruins in Ayutthaya, enjoying street food under neon lights, or island-hopping in the Andaman Sea, you'll be greeted with warm hospitality and awe-inspiring landscapes. The country's mix of tradition and modernity makes it a top choice for first-timers and seasoned explorers alike.
  
      Known as the Land of Smiles, Thailand promises a colorful blend of festivals, jungle adventures, cultural insights, and unforgettable relaxation—all within one journey.
    `,
    gallery: [
      "/country/Thailand/thailand1.jpg",
      "/country/Thailand/thailand2.jpg",
      "/country/Thailand/thailand3.jpg",
      "/country/Thailand/thailand4.jpg",
      "/country/Thailand/thailand5.jpg",
      "/country/Thailand/thailand6.jpg",
      "/country/Thailand/thailand7.jpg",
      "/country/Thailand/thailand8.jpg",
      "/country/Thailand/thailand9.jpg",
      "/country/Thailand/thailand10.jpg",
    ],
    highlights: [
      "Visit the majestic Grand Palace and Wat Pho in Bangkok",
      "Island-hop around Phi Phi, James Bond Island, and Similan Islands",
      "Ride a long-tail boat through the floating markets of Damnoen Saduak",
      "Enjoy traditional Thai massage and spa treatments",
      "Experience the Yi Peng Lantern Festival in Chiang Mai",
      "Explore the ruins of the ancient capital Ayutthaya",
      "Trek through lush northern jungles and hill tribes",
      "Feast on world-famous Thai street food like Pad Thai and Mango Sticky Rice"
    ],
    basicInfo: {
      "Destination": "Thailand",
      "Entry Point": "Bangkok Suvarnabhumi or Phuket International Airport",
      "Official Language": "Thai (English spoken in tourist areas)",
      "Currency": "Thai Baht (THB)",
      "Visa Requirement": "Visa-free or visa-on-arrival for most countries",
      "Best Travel Time": "November to March (cool, dry season)",
      "Travel Group Size": "Ideal for solo travelers, couples, and groups",
      "Time Zone": "GMT+7"
    },
    included: [
      "Airport transfers and internal transport",
      "Handpicked 3-star/4-star accommodations",
      "Guided tours in Bangkok, Chiang Mai, and islands",
      "Daily breakfast and select Thai dinners",
      "Long-tail boat and ferry transfers",
      "Entrance fees for temples and historical parks"
    ],
    tips: [
      "Respect local customs—dress modestly at temples",
      "Tuk-tuks are fun but agree on a price before the ride",
      "Carry cash—many vendors don’t accept cards",
      "Tap water is not safe to drink—use bottled water",
      "Beware of tourist scams, especially around major landmarks",
      "Use mosquito repellent in jungle or coastal areas"
    ]
  },
  
  {
    id: 4,
    name: "Switzerland",
    image: "/images/destinations/switzerland.jpg",
    rating: 4.8,
    days: 7,
    categories: ["Winter Activities", "Mountains"],
    months: ["January"],
    title: "Unwind in the Heart of the Alps – Your Swiss Adventure Awaits",
    description: `
      Switzerland is a land where alpine charm meets cosmopolitan elegance. Known for its snow-capped peaks, scenic train journeys, pristine lakes, and medieval towns, it offers a picture-perfect escape every season—especially winter. From skiing in the Swiss Alps to leisurely cruises on Lake Lucerne, the country blends relaxation with thrill effortlessly.
      
      The experience is as rich culturally as it is visually: stroll through charming old towns like Lucerne and Bern, ride the panoramic Glacier Express, and indulge in world-famous Swiss chocolates and cheeses. With efficient transport, welcoming locals, and breathtaking landscapes, Switzerland makes every traveler feel at home and inspired.
    `,
    gallery: [
      "/country/Switzerland/switzerland1.jpg",
      "/country/Switzerland/switzerland2.jpg",
      "/country/Switzerland/switzerland3.jpg",
      "/country/Switzerland/switzerland4.jpg",
      "/country/Switzerland/switzerland5.jpg",
      "/country/Switzerland/switzerland6.jpg",
      "/country/Switzerland/switzerland7.jpg",
      "/country/Switzerland/switzerland8.jpg",
      "/country/Switzerland/switzerland9.jpg",
      "/country/Switzerland/switzerland10.jpg",
    ],

    highlights: [
      "Ride the iconic Glacier Express through the Alps",
      "Ski or snowboard in Zermatt or St. Moritz",
      "Cruise over Lake Lucerne at sunset",
      "Explore the medieval charm of Lucerne and Bern",
      "Visit the Matterhorn—one of the most iconic peaks in the world",
      "Tour cheese and chocolate factories for a true taste of Switzerland",
      "Take scenic hikes in Lauterbrunnen Valley",
      "Marvel at the Rhine Falls, Europe's largest waterfall"
    ],
    basicInfo: {
      "Destination": "Switzerland",
      "Entry Point": "Zurich / Geneva International Airport",
      "Official Languages": "German, French, Italian, Romansh",
      "Currency": "Swiss Franc (CHF)",
      "Visa Requirement": "Schengen Visa required for most nationalities",
      "Best Travel Time": "December to March (for winter activities)",
      "Travel Group Size": "Small to medium groups",
      "Time Zone": "GMT+1"
    },
    included: [
      "4-star or boutique hotel accommodations",
      "Daily breakfast and local city taxes",
      "Swiss rail passes or train transfers",
      "Panoramic train journeys (e.g., Glacier Express)",
      "Excursions to Jungfraujoch or Matterhorn (optional)",
      "Airport-hotel transfers",
      "Local sightseeing tours and walking guides"
    ],
    tips: [
      "Pack layers—even summer evenings can be chilly in the mountains.",
      "Swiss transport runs on exact time—always arrive early.",
      "Switzerland is expensive—budget accordingly or buy multi-day passes.",
      "Carry a universal power adapter (Swiss outlets are unique).",
      "Respect local quiet hours, especially in villages and residential areas.",
      "Public fountains often offer drinkable water—carry a refillable bottle."
    ]
  },  
  {
    id: 5,
    name: "France",
    image: "/country/France/france1.jpg",
    rating: 4.8,
    days: 7,
    categories: ["Landscape", "Winter Activities"],
    months: ["January", "May", "December", "June"],
    title: "Fall in Love with the Romance and Richness of France",
    description: `
      France is where elegance meets history and every street corner feels like a painting. Whether you're walking through the charming alleys of Montmartre in Paris, savoring wine in Bordeaux, or skiing down the snowy slopes of the French Alps, France offers a seamless blend of cultural richness and natural beauty.
  
      The country invites you to experience world-class art in the Louvre, the grandeur of Versailles, and the sparkling allure of the French Riviera. With its vibrant festivals, mouthwatering cuisine, and centuries of architectural marvels, France is a timeless escape that awakens your senses and leaves your heart full.
  
      From romantic getaways to alpine adventures, France is a destination where every moment feels unforgettable.
    `,
    gallery: [
      "/country/France/france1.jpg",
      "/country/France/france2.jpg",
      "/country/France/france3.jpg",
      "/country/France/france4.jpg",
      "/country/France/france5.jpg",
      "/country/France/france6.jpg",
      "/country/France/france7.jpg",
      "/country/France/france8.jpg",
      "/country/France/france9.jpg",
      "/country/France/france10.jpg",
    ],
    highlights: [
      "Witness the Eiffel Tower light show in Paris",
      "Sip wine in the vineyards of Bordeaux and Champagne",
      "Explore historic castles in the Loire Valley",
      "Ski in the breathtaking French Alps",
      "Walk along the sparkling beaches of the Côte d'Azur",
      "Marvel at art masterpieces in the Louvre and Musée d'Orsay",
      "Enjoy French pastries and café culture in every town"
    ],
    basicInfo: {
      "Destination": "France",
      "Entry Point": "Charles de Gaulle (Paris), Nice, Lyon Airports",
      "Official Language": "French",
      "Currency": "Euro (EUR)",
      "Visa Requirement": "Schengen Visa required for most non-EU travelers",
      "Best Travel Time": "April to June (spring) & September to November (fall)",
      "Travel Group Size": "Ideal for couples, solo travelers, and families",
      "Time Zone": "GMT+1"
    },
    included: [
      "Boutique and luxury hotel stays",
      "Daily breakfast and guided excursions",
      "Train or coach travel between regions",
      "Museum and monument entry tickets",
      "Wine tasting experiences",
      "Local guides for cultural tours"
    ],
    tips: [
      "Carry a universal power adapter (Type E plug).",
      "Learn basic French greetings — locals appreciate the effort.",
      "Public transport is reliable but metros can be crowded.",
      "Restaurants often close between lunch and dinner — plan meal times.",
      "Tipping is not obligatory but rounding up is common courtesy.",
      "Many museums are closed on Mondays — check before visiting."
    ]
  },  
  {
    id: 6,
    name: "Cancun",
    image: "/country/Cancun/cancun1.jpg",
    rating: 4.8,
    days: 7,
    categories: ["Beaches"],
    months: ["February"],
    title: "Unwind in Paradise: Discover the Magic of Cancun",
    description: `
      Cancun is the crown jewel of Mexico’s Caribbean coast — a perfect blend of tropical leisure, rich culture, and endless turquoise waters. Known for its white-sand beaches, vibrant nightlife, and luxurious all-inclusive resorts, Cancun caters to both relaxation seekers and thrill-chasers alike.
  
      Lounge beneath swaying palm trees with a cocktail in hand, take a catamaran ride across the crystal-clear sea, or dive into the mesmerizing underwater world of cenotes and coral reefs. For history lovers, nearby Mayan ruins like Tulum and Chichen Itza offer a glimpse into an ancient civilization with unforgettable backdrops.
  
      Whether you’re here for the sun, the sea, or the stories, Cancun promises a vibrant escape that rejuvenates your soul and excites your senses.
    `,
    gallery: [
      "/country/Cancun/cancun1.jpg",
      "/country/Cancun/cancun2.jpg",
      "/country/Cancun/cancun3.jpg",
      "/country/Cancun/cancun4.jpg",
      "/country/Cancun/cancun5.jpg",
      "/country/Cancun/cancun6.jpg",
      "/country/Cancun/cancun7.jpg",
      "/country/Cancun/cancun8.jpg",
      "/country/Cancun/cancun9.jpg",
    ],
    highlights: [
      "Relax on the powdery beaches of Playa Delfines and Playa Norte",
      "Snorkel or scuba dive in the Great Mesoamerican Reef",
      "Visit ancient Mayan ruins at Tulum and Chichen Itza",
      "Enjoy a jungle adventure at Xcaret or Xplor theme parks",
      "Dance the night away in Cancun’s famous Hotel Zone clubs",
      "Take a boat to Isla Mujeres for a peaceful day trip"
    ],
    basicInfo: {
      "Destination": "Cancun, Mexico",
      "Entry Point": "Cancun International Airport (CUN)",
      "Official Language": "Spanish (English widely spoken in tourist areas)",
      "Currency": "Mexican Peso (MXN)",
      "Visa Requirement": "Visa-free for many nationalities (up to 180 days)",
      "Best Travel Time": "December to April (dry season)",
      "Travel Group Size": "Ideal for couples, families, or groups of friends",
      "Time Zone": "GMT-5"
    },
    included: [
      "All-inclusive resort stays",
      "Daily meals and drinks",
      "Round-trip airport transfers",
      "One guided excursion (e.g., Chichen Itza or snorkel trip)",
      "On-site entertainment and activities",
      "Travel insurance (basic coverage)"
    ],
    tips: [
      "Use reef-safe sunscreen to protect marine life while swimming.",
      "Negotiate prices at local markets before purchasing.",
      "Tap water isn’t drinkable — stick to bottled water.",
      "USD is accepted in many places, but paying in Pesos can be cheaper.",
      "Book excursions in advance during peak season to avoid sold-out tours."
    ]
  },  
  {
    id: 7,
    name: "Dubai",
    image: "/images/destinations/dubai.jpg",
    rating: 4.8,
    days: 7,
    categories: ["Adventure"],
    months: ["February", "November"],
    title: "Experience Luxury and Thrill: Your Dubai Adventure Awaits",
    description: `
      Dubai is a dazzling oasis in the Arabian desert where tradition meets innovation. With its futuristic skyline, luxurious experiences, and deep-rooted Emirati culture, Dubai offers something for every kind of traveler. From sky-piercing towers to golden dunes, it’s a destination that constantly reinvents itself.
  
      Visit iconic landmarks like the Burj Khalifa and the sail-shaped Burj Al Arab, shop in ultra-modern malls or traditional souks, and unwind at world-class resorts. For adrenaline junkies, desert safaris, dune bashing, skydiving, and waterparks deliver unforgettable thrills.
  
      Whether you’re marveling at architectural wonders or enjoying sunset views on a yacht, Dubai transforms a holiday into a high-octane memory, wrapped in style and sophistication.
    `,
    gallery: [
      "/country/Dubai/dubai1.jpg",
      "/country/Dubai/dubai2.jpg",
      "/country/Dubai/dubai3.jpg",
      "/country/Dubai/dubai4.jpg",
      "/country/Dubai/dubai5.jpg",
      "/country/Dubai/dubai6.jpg",
      "/country/Dubai/dubai7.jpg",
      "/country/Dubai/dubai8.jpg",
      "/country/Dubai/dubai9.jpg",
      "/country/Dubai/dubai10.jpg",
      "/country/Dubai/dubai11.jpg",
      "/country/Dubai/dubai12.jpg",
      "/country/Dubai/dubai13.jpg",
      "/country/Dubai/dubai14.jpg",
    ],
    highlights: [
      "Witness breathtaking views from the Burj Khalifa's observation deck",
      "Go dune bashing and ride camels in a desert safari experience",
      "Enjoy luxury shopping in Dubai Mall and Mall of the Emirates",
      "Skydive over the iconic Palm Jumeirah",
      "Cruise Dubai Marina on a private yacht or traditional dhow",
      "Relax at The Atlantis or visit Aquaventure Waterpark",
      "Explore history in the Al Fahidi Historic District and Dubai Museum"
    ],
    basicInfo: {
      "Destination": "Dubai, United Arab Emirates",
      "Entry Point": "Dubai International Airport (DXB)",
      "Official Language": "Arabic (English widely spoken)",
      "Currency": "UAE Dirham (AED)",
      "Visa Requirement": "Visa on arrival for many nationalities",
      "Best Travel Time": "November to March (cool and pleasant)",
      "Travel Group Size": "Great for couples, families, and luxury seekers",
      "Time Zone": "GMT+4"
    },
    included: [
      "Luxury hotel accommodation",
      "Daily breakfast buffet",
      "Airport pick-up and drop-off in private car",
      "Desert safari with BBQ dinner and cultural show",
      "Burj Khalifa entry ticket",
      "Dubai Marina yacht cruise or dhow dinner cruise",
      "Travel insurance (basic coverage)"
    ],
    tips: [
      "Dress modestly in public spaces and religious sites.",
      "Public displays of affection are discouraged.",
      "Friday is a holy day — plan activities accordingly.",
      "Taxis and ride-hailing apps like Careem are safe and reliable.",
      "Alcohol is served only in licensed hotels and bars.",
      "Tap water is safe, but bottled water is preferred by many."
    ]
  },  
  {
    id: 8,
    name: "Azerbaijan",
    image: "/country/Azerbaijan/azerbaijan1.jpg",
    rating: 4.8,
    days: 7,
    categories: ["Adventure", "Landscape"],
    months: ["February"],
    title: "Unveil the Secrets of the Caucasus: Discover Azerbaijan’s Rugged Beauty",
    description: `
      Azerbaijan, the Land of Fire, is where ancient traditions meet modern marvels across a dramatic landscape of mountains, mud volcanoes, and Caspian Sea shores. This captivating country offers a fusion of East and West, with Islamic architecture, Soviet-era history, and futuristic flame-shaped skyscrapers all coexisting in harmony.
  
      Explore the medieval streets of Baku’s Old City, wander past grand palaces and mosques, or ascend to the heights of the Caucasus Mountains in Gabala. Whether you're intrigued by ancient petroglyphs in Gobustan, soothed by natural thermal springs, or dazzled by the flickering fire of Yanar Dag, Azerbaijan offers a journey like no other.
  
      It’s a destination that rewards curiosity — every region opens a new chapter of history, nature, and adventure.
    `,
    gallery: [
      "/country/Azerbaijan/azerbaijan1.jpg",
      "/country/Azerbaijan/azerbaijan2.jpg",
      "/country/Azerbaijan/azerbaijan3.jpg",
      "/country/Azerbaijan/azerbaijan4.jpg",
      "/country/Azerbaijan/azerbaijan5.jpg",
      "/country/Azerbaijan/azerbaijan6.jpg",
      "/country/Azerbaijan/azerbaijan7.jpg",
      "/country/Azerbaijan/azerbaijan9.jpg",
      "/country/Azerbaijan/azerbaijan10.jpg",
    ],
    highlights: [
      "Stroll through Baku’s UNESCO-listed Old City (Icherisheher)",
      "Witness the eternal flames at Yanar Dag (Burning Mountain)",
      "Visit the Heydar Aliyev Center – a masterpiece of modern architecture",
      "Explore the rock carvings of Gobustan National Park",
      "Ride cable cars and ski in the Caucasus Mountains (Tufandag or Shahdag)",
      "Soak in natural mud volcanoes and hot springs",
      "Experience local culture with carpet weaving workshops and tea houses"
    ],
    basicInfo: {
      "Destination": "Azerbaijan",
      "Entry Point": "Heydar Aliyev International Airport, Baku",
      "Official Language": "Azerbaijani (English and Russian are also spoken)",
      "Currency": "Azerbaijani Manat (AZN)",
      "Visa Requirement": "E-visa required for most nationalities",
      "Best Travel Time": "April to June & September to November (pleasant climate)",
      "Travel Group Size": "Ideal for explorers, photographers, and small groups",
      "Time Zone": "GMT+4"
    },
    included: [
      "3-star to 5-star hotel options across Baku and mountain regions",
      "Daily breakfast and select traditional meals",
      "Airport transfers and inter-city transport",
      "Entry tickets to major cultural landmarks and museums",
      "Local guide for city and regional tours",
      "Mountain excursion transport and activities",
      "Travel insurance (basic coverage)"
    ],
    tips: [
      "Carry some cash as rural areas may not accept cards.",
      "Dress modestly when visiting mosques or local homes.",
      "Bargaining is acceptable in local markets.",
      "Public transport is reliable in Baku — metro and taxis are common.",
      "Avoid tap water in remote areas — bottled water is recommended.",
      "Respect local traditions — hospitality is a big part of Azerbaijani culture."
    ]
  },  
  {
    id: 9,
    name: "Georgia",
    image: "/images/destinations/georgia.jpg",
    rating: 4.8,
    days: 7,
    categories: ["Winter Activities","Landscape"],
    months: ["February"],
    title: "Escape to the Caucasus: Experience Georgia’s Snowy Charms & Timeless Traditions",
    description: `
      Georgia is a captivating destination where snowy peaks meet ancient monasteries and warm hospitality fills every mountain lodge. Nestled in the heart of the Caucasus, it offers a perfect blend of winter adventure, cultural depth, and culinary excellence.
  
      In February, the slopes of Gudauri and Bakuriani come alive with skiing, snowboarding, and alpine thrills, all set against breathtaking landscapes. But Georgia isn't just about snow — it's about the warm supra feasts, the soulful polyphonic music, and the deep-rooted traditions of a nation that has welcomed travelers for millennia.
  
      From Tbilisi’s vibrant Old Town to the whitewashed churches of Mtskheta and the hot sulfur baths beneath Narikala Fortress, every step in Georgia is a story waiting to unfold.
    `,
    gallery: [
      "/country/Georgia/georgia1.jpg",
      "/country/Georgia/georgia2.jpg",
      "/country/Georgia/georgia3.jpg",
      "/country/Georgia/georgia4.jpg",
      "/country/Georgia/georgia5.jpg",
      "/country/Georgia/georgia6.jpg",
      "/country/Georgia/georgia7.jpg",
    ],
    highlights: [
      "Ski and snowboard at Gudauri, Georgia’s premier winter resort",
      "Stroll through the cobbled streets of Old Tbilisi",
      "Relax in traditional sulfur baths with mountain views",
      "Visit the ancient capital of Mtskheta and Svetitskhoveli Cathedral",
      "Enjoy Georgian polyphonic music and dance performances",
      "Savor khinkali dumplings and khachapuri with local wine",
      "Take a cable car ride to the Narikala Fortress for panoramic views"
    ],
    basicInfo: {
      "Destination": "Georgia",
      "Entry Point": "Tbilisi International Airport",
      "Official Language": "Georgian (English and Russian commonly spoken)",
      "Currency": "Georgian Lari (GEL)",
      "Visa Requirement": "Visa-free or e-Visa for most nationalities",
      "Best Travel Time": "December to February (for snow sports)",
      "Travel Group Size": "Perfect for couples, families, and winter adventurers",
      "Time Zone": "GMT+4"
    },
    included: [
      "Mountain resort accommodations with breakfast",
      "Airport transfers and private intercity transport",
      "Lift passes and ski gear rental options (if selected)",
      "City tours in Tbilisi and Mtskheta with local guide",
      "Cultural performance and wine tasting evening",
      "Sulfur bath experience voucher",
      "Travel insurance (basic coverage)"
    ],
    tips: [
      "Layer up — Georgian winters can be very cold in the mountains.",
      "Georgian wine is world-famous — don’t leave without a tasting.",
      "Public Wi-Fi is common in cities but limited in rural areas.",
      "Card payments are accepted in major cities, cash is preferred in small towns.",
      "Try to learn a few Georgian phrases — locals appreciate the effort.",
      "Be respectful in churches — headscarves for women are encouraged."
    ]
  },  
  {
    id: 10,
    name: "Florida",
    image: "/images/destinations/florida.jpg",
    rating: 4.8,
    days: 7,
    categories: ["Beaches"],
    months: ["March"],
    title: "Soak in the Sun and Fun: Florida Awaits with Endless Coastal Adventures",
    description: `
      Florida is a vibrant paradise where sunny skies meet sandy beaches, thrilling theme parks, and a lifestyle of laid-back leisure. Whether you're craving the energy of Miami’s nightlife, the serenity of the Florida Keys, or the family fun of Orlando’s attractions, March is the perfect time to explore the Sunshine State.
  
      From snorkeling in turquoise waters and airboating through the Everglades to strolling historic streets in St. Augustine or tasting Cuban coffee in Little Havana, Florida’s diversity offers something for everyone. With warm weather and endless coastlines, it's the ultimate escape from winter blues.
  
      Discover art deco glamour, wildlife encounters, and world-class entertainment — all wrapped in Florida’s signature warmth and charm.
    `,
    gallery: [
      "/country/Florida/florida1.jpg",
      "/country/Florida/florida2.jpg",
      "/country/Florida/florida3.jpg",
      "/country/Florida/florida4.jpg",
      "/country/Florida/florida5.jpg",
      "/country/Florida/florida6.jpg",
    ],
    highlights: [
      "Relax on the beaches of Miami, Clearwater, and Siesta Key",
      "Visit world-famous theme parks like Disney World and Universal Studios",
      "Explore the Everglades on an airboat safari",
      "Snorkel or dive in the coral reefs of the Florida Keys",
      "Tour the art deco architecture of South Beach",
      "Take a sunset cruise off Naples or Fort Myers",
      "Visit Kennedy Space Center for an out-of-this-world experience"
    ],
    basicInfo: {
      "Destination": "Florida, USA",
      "Entry Point": "Miami, Orlando, or Tampa International Airport",
      "Official Language": "English",
      "Currency": "US Dollar (USD)",
      "Visa Requirement": "ESTA for eligible countries or B-2 Tourist Visa",
      "Best Travel Time": "March to May (pleasant weather, spring festivals)",
      "Travel Group Size": "Great for families, couples, and solo travelers",
      "Time Zone": "GMT-5 (Eastern Standard Time)"
    },
    included: [
      "Accommodation in centrally located resorts or beachside hotels",
      "Airport transfers and local transportation",
      "Entry to major theme parks (based on package)",
      "Guided Everglades tour or beach day trip",
      "Breakfasts included at select accommodations",
      "Travel insurance (basic US coverage)"
    ],
    tips: [
      "Florida weather is sunny but humid — pack light and breathable clothes.",
      "Apply reef-safe sunscreen to protect marine ecosystems.",
      "Renting a car is convenient for beach-hopping and theme parks.",
      "Watch for sudden afternoon showers — carry a light rain jacket.",
      "Tipping is expected in restaurants and for services (15–20%).",
      "Book theme park tickets in advance to avoid long queues."
    ]
  },  
  {
    id: 11,
    name: "Japan",
    image: "/images/destinations/japan.jpg",
    rating: 4.8,
    days: 7,
    categories: ["Adventure","Kid Friendly"],
    months: ["March"],
    title: "Witness the Magic of Sakura Season: Discover Japan in Full Bloom",
    description: `
      Japan in March is nothing short of magical — the season when delicate cherry blossoms blanket the landscape in shades of pink and white. It's a time when centuries-old traditions meet modern marvels, creating a travel experience that is both serene and stimulating.
  
      Whether you're walking beneath blooming sakura trees in Kyoto, exploring the vibrant streets of Tokyo, or soaking in a traditional onsen with mountain views, Japan offers a harmonious blend of nature, culture, and innovation. From sushi counters to sumo matches, bullet trains to bamboo forests, every moment here is unforgettable.
  
      March brings pleasant weather and fewer crowds, making it the perfect time to experience Japanese hospitality, aesthetics, and the fleeting beauty of spring.
    `,
    gallery: [
      "/country/Japan/japan1.jpg",
      "/country/Japan/japan2.jpg",
      "/country/Japan/japan3.jpg",
      "/country/Japan/japan4.jpg",
      "/country/Japan/japan5.jpg",
      "/country/Japan/japan6.jpg",
      "/country/Japan/japan7.jpg",
      "/country/Japan/japan8.jpg",
      "/country/Japan/japan9.jpg",
    ],
    highlights: [
      "View cherry blossoms at iconic spots like Ueno Park, Kyoto’s Philosopher’s Path, and Himeji Castle",
      "Experience traditional tea ceremonies and cultural festivals",
      "Ride the Shinkansen (bullet train) through scenic countryside",
      "Explore temples, shrines, and bamboo groves in Kyoto and Nara",
      "Shop and dine in futuristic Tokyo districts like Shibuya and Akihabara",
      "Soak in natural hot springs (onsen) in Hakone or Beppu",
      "Stay at a ryokan (traditional Japanese inn) with kaiseki meals"
    ],
    basicInfo: {
      "Destination": "Japan",
      "Entry Point": "Tokyo (Narita/Haneda) or Osaka (Kansai) International Airport",
      "Official Language": "Japanese",
      "Currency": "Japanese Yen (JPY)",
      "Visa Requirement": "Visa-free or eVisa for many nationalities (check current policy)",
      "Best Travel Time": "March to May (spring blossom season)",
      "Travel Group Size": "Ideal for couples, families, and cultural explorers",
      "Time Zone": "GMT+9 (Japan Standard Time)"
    },
    included: [
      "Accommodation in centrally located hotels or ryokans",
      "Daily breakfast and selected traditional dinners",
      "JR Rail Pass for intercity travel (limited use packages)",
      "Guided city tours and temple visits",
      "Entrance fees to selected cultural landmarks",
      "Airport transfers",
      "Travel insurance (basic coverage)"
    ],
    tips: [
      "Respect quietness in public transport — phone calls are discouraged.",
      "Carry cash as many local shops and restaurants do not accept cards.",
      "Use coin lockers at train stations for luggage convenience.",
      "Try convenience store meals — they’re fresh, cheap, and delicious.",
      "Learn basic Japanese phrases or download a translation app.",
      "Book cherry blossom viewing spots and local transport early — they fill up fast during March."
    ]
  },  
  {
    id: 12,
    name: "South Korea",
    image: "/images/destinations/south_korea.jpg",
    rating: 4.8,
    days: 7,
    categories: ["Adventure","Kid Friendly"],
    months: ["March"],
    title: "Celebrate Spring in Full Bloom: Discover the Charm of South Korea",
    description: `
      South Korea in March is a breathtaking spectacle as cherry blossoms begin to bloom, turning parks, palaces, and streets into dreamy landscapes. This is the perfect time to experience Korea's deep-rooted traditions alongside its futuristic flair — all wrapped in a season of renewal.
  
      Stroll through ancient palaces in Seoul surrounded by pink blossoms, hike up scenic mountains with panoramic spring views, and wander through hanok villages where history lives on. South Korea combines natural beauty with modern energy, whether you're exploring K-pop culture in Gangnam or enjoying peaceful temple stays in the mountains.
  
      From street food adventures to high-tech shopping districts, March is ideal for travelers who want mild weather, colorful scenery, and rich cultural immersion.
    `,
    gallery: [
      "/country/SouthKorea/korea1.jpg",
      "/country/SouthKorea/korea2.jpg",
      "/country/SouthKorea/korea3.jpg",
      "/country/SouthKorea/korea4.jpg",
      "/country/SouthKorea/korea5.jpg",
      "/country/SouthKorea/korea6.jpg",
      "/country/SouthKorea/korea7.jpg",
      "/country/SouthKorea/korea8.jpg",
      "/country/SouthKorea/korea9.jpg",
      "/country/SouthKorea/korea10.jpg",
      "/country/SouthKorea/korea11.jpg",
    ],
    highlights: [
      "View cherry blossoms at Yeouido Park, Gyeongbokgung Palace, and Jinhae Festival",
      "Visit traditional hanok villages in Bukchon and Jeonju",
      "Experience K-pop culture and fashion in Myeongdong and Gangnam",
      "Hike scenic trails at Bukhansan and Seoraksan National Parks",
      "Enjoy Korean BBQ, street food, and tea ceremonies",
      "Explore centuries-old palaces and Buddhist temples",
      "Relax in jjimjilbang (Korean spas) after a day of sightseeing"
    ],
    basicInfo: {
      "Destination": "South Korea",
      "Entry Point": "Incheon International Airport (Seoul)",
      "Official Language": "Korean",
      "Currency": "South Korean Won (KRW)",
      "Visa Requirement": "Visa-free or K-ETA for many nationalities (check latest policy)",
      "Best Travel Time": "March to May (spring/cherry blossom season)",
      "Travel Group Size": "Great for solo travelers, friends, and culture seekers",
      "Time Zone": "GMT+9 (Korea Standard Time)"
    },
    included: [
      "Accommodation in 3-star or 4-star hotels",
      "Daily breakfast and selected dinners",
      "Airport transfers and local transport passes",
      "English-speaking guide for cultural tours",
      "Entrance tickets to key heritage sites and palaces",
      "Temple stay or hanok night experience (optional)",
      "Travel insurance (basic coverage)"
    ],
    tips: [
      "Download Naver Map or KakaoMap — Google Maps has limited accuracy.",
      "T-Money card is essential for buses, subways, and taxis.",
      "Public Wi-Fi is widespread and fast, but carry a backup SIM or pocket Wi-Fi.",
      "Respect age hierarchy and etiquette when greeting or dining with locals.",
      "Street food is safe and a must-try — visit Gwangjang or Myeongdong markets.",
      "Pack layers — March mornings and evenings can still be chilly."
    ]
  },  
  {
    id: 13,
    name: "Sri Lanka",
    image: "/images/destinations/sri_lanka.jpg",
    rating: 4.8,
    days: 7,
    categories: ["Landscape","Beaches","Wildlife"],
    months: ["March"],
    title: "Uncover the Wonders of the Teardrop Island: Journey Through Sri Lanka",
    description: `
      Sri Lanka is a jewel-shaped island that offers an intoxicating blend of nature, history, and culture. March is the ideal month to visit, offering dry and sunny weather along the southern coast and central hills. With lush green landscapes, golden beaches, and ancient ruins, Sri Lanka invites you on a journey of discovery and relaxation.
  
      Explore centuries-old temples in Kandy, take a scenic train ride through tea plantations in Ella, and bask in the coastal charm of Galle. Wildlife lovers can spot elephants and leopards in national parks, while spiritual travelers can visit sacred sites like the Temple of the Tooth and Adam’s Peak.
  
      From spicy cuisine to warm hospitality and serene beaches, Sri Lanka delivers unforgettable memories at every turn.
    `,
    gallery: [
      "/country/SriLanka/lanka1.jpg",
      "/country/SriLanka/lanka2.jpg",
      "/country/SriLanka/lanka3.jpg",
      "/country/SriLanka/lanka4.jpg",
      "/country/SriLanka/lanka5.jpg",
      "/country/SriLanka/lanka6.jpg",
      "/country/SriLanka/lanka7.jpg",
      "/country/SriLanka/lanka8.jpg",
      "/country/SriLanka/lanka9.jpg",
    ],
    highlights: [
      "Ride the scenic train from Kandy to Ella through misty tea plantations",
      "Relax on pristine beaches in Bentota, Mirissa, or Unawatuna",
      "Visit the Temple of the Tooth in Kandy — a sacred Buddhist site",
      "Spot elephants, leopards, and birds in Yala or Udawalawe National Park",
      "Explore colonial-era Galle Fort and its cobbled streets",
      "Hike to the top of Sigiriya Rock Fortress — a UNESCO World Heritage Site",
      "Discover Ayurvedic wellness retreats and ancient healing practices"
    ],
    basicInfo: {
      "Destination": "Sri Lanka",
      "Entry Point": "Bandaranaike International Airport (Colombo)",
      "Official Language": "Sinhala, Tamil (English widely spoken)",
      "Currency": "Sri Lankan Rupee (LKR)",
      "Visa Requirement": "Electronic Travel Authorization (ETA) required prior to arrival",
      "Best Travel Time": "December to April (south and west coast)",
      "Travel Group Size": "Suitable for families, couples, and solo travelers",
      "Time Zone": "GMT+5:30"
    },
    included: [
      "Accommodation in boutique and star-rated hotels",
      "Daily breakfast and guided excursions",
      "Airport transfers and air-conditioned private vehicle",
      "Entrance fees to key cultural and heritage sites",
      "Scenic train journey tickets (Kandy to Ella)",
      "National park safari entry and guide",
      "Local sim card or Wi-Fi dongle (on request)"
    ],
    tips: [
      "Dress modestly when visiting temples — shoulders and knees should be covered.",
      "Carry cash, especially in rural areas — ATMs may not be widely available.",
      "Tap water is not safe to drink — use bottled or filtered water.",
      "Avoid public displays of affection in conservative areas.",
      "Negotiate tuk-tuk fares before starting your ride.",
      "March can be hot inland — carry sunscreen, hats, and stay hydrated."
    ]
  },  
  {
    id: 14,
    name: "Bali",
    image: "/country/Bali/bali1.jpg",
    rating: 4.8,
    days: 7,
    categories: ["Adventure", "Beaches"],
    months: ["April", "August"],
    title: "Reconnect, Recharge, and Reimagine in the Tropical Paradise of Bali",
    description: `
      Bali, Indonesia’s most beloved island, is a dreamscape of lush jungles, world-famous surf beaches, and deep spiritual energy. Whether you're a thrill-seeker, nature lover, or wellness traveler, Bali welcomes you with open arms and unforgettable moments.
  
      In April and August, Bali enjoys its dry season — making it perfect for adventure activities and beach lounging. Discover terraced rice paddies in Ubud, experience the mysticism of ancient temples like Uluwatu and Besakih, and chase waterfalls in the island's north.
  
      From the rhythmic beats of traditional Kecak dances to the tranquil vibes of yoga retreats and beachfront resorts, Bali offers a soulful escape and the freedom to explore at your own pace.
    `,
    gallery: [
      "/country/Bali/bali1.jpg",
      "/country/Bali/bali2.jpg",
      "/country/Bali/bali3.jpg",
      "/country/Bali/bali4.jpg",
      "/country/Bali/bali5.jpg",
      "/country/Bali/bali6.jpg",
      "/country/Bali/bali7.jpg",
      "/country/Bali/bali8.jpg",
      "/country/Bali/bali9.jpg",
      "/country/Bali/bali10.jpg",
      "/country/Bali/bali11.jpg",
    ],
    highlights: [
      "Witness a fiery sunset at Uluwatu Temple perched on a cliff",
      "Trek up Mount Batur to watch sunrise from above the clouds",
      "Relax on beaches like Seminyak, Nusa Dua, and Padang Padang",
      "Discover sacred sites like Tirta Empul and Goa Gajah (Elephant Cave)",
      "Enjoy traditional Balinese cooking classes and local markets",
      "Swing over rice terraces and waterfalls in Ubud",
      "Dive or snorkel in crystal-clear waters at Amed or Nusa Penida"
    ],
    basicInfo: {
      "Destination": "Bali, Indonesia",
      "Entry Point": "Ngurah Rai International Airport (Denpasar)",
      "Official Language": "Bahasa Indonesia (English commonly spoken)",
      "Currency": "Indonesian Rupiah (IDR)",
      "Visa Requirement": "Visa-free or visa-on-arrival for many nationalities",
      "Best Travel Time": "April to October (dry season)",
      "Travel Group Size": "Suitable for couples, friends, and solo travelers",
      "Time Zone": "GMT+8"
    },
    included: [
      "Hotel and villa accommodations with breakfast",
      "Airport pick-up and drop-off",
      "Daily guided tours with private driver",
      "Entrance fees to major temples and attractions",
      "Trekking and sunrise hike (optional)",
      "Cultural dance show tickets (where included)",
      "Traditional lunch or dinner experiences"
    ],
    tips: [
      "Respect local customs — always wear a sarong in temples.",
      "Taxis are better booked through apps like Grab or Bluebird.",
      "Beware of monkeys in temple areas — keep belongings safe.",
      "Bring cash for local shops and small eateries.",
      "Use reef-safe sunscreen and avoid stepping on corals.",
      "Stay hydrated and carry mosquito repellent, especially in jungle areas."
    ]
  },  
  {
    id: 15,
    name: "Netherlands",
    image: "/images/destinations/netherlands.jpg",
    rating: 4.8,
    days: 7,
    categories: ["Landscape"],
    months: ["April"],
    title: "Celebrate Spring in the Netherlands — Tulips, Canals & Culture Await",
    description: `
      April in the Netherlands transforms the country into a living postcard of vibrant tulip fields, charming windmills, and bustling city life. This is the season of color, energy, and iconic Dutch experiences.
  
      Explore the Keukenhof Gardens in full bloom — a mesmerizing sea of tulips, daffodils, and hyacinths stretching as far as the eye can see. Cruise through Amsterdam's historic canals, wander through cobbled streets lined with cafés and museums, and discover why Dutch bicycle culture is beloved around the world.
  
      With King’s Day festivities lighting up the streets in April, you’ll experience the Netherlands at its happiest. From quiet countryside retreats to vibrant city adventures, the Dutch landscape offers a perfect balance of relaxation and celebration.
    `,
    gallery: [
      "/country/Netherlands/netherlands1.jpg",
      "/country/Netherlands/netherlands2.jpg",
      "/country/Netherlands/netherlands3.jpg",
      "/country/Netherlands/netherlands4.jpg",
      "/country/Netherlands/netherlands5.jpg",
      "/country/Netherlands/netherlands6.jpg",
      "/country/Netherlands/netherlands7.jpg",
      "/country/Netherlands/netherlands8.jpg",
      "/country/Netherlands/netherlands9.jpg",
      "/country/Netherlands/netherlands10.jpg",
    ],
    highlights: [
      "Witness the breathtaking tulip fields near Lisse",
      "Cruise through Amsterdam's UNESCO-listed canals",
      "Celebrate King’s Day in orange with locals and parades",
      "Explore historic towns like Delft, Haarlem, and Utrecht",
      "Visit Van Gogh Museum and Rijksmuseum",
      "Cycle through the peaceful countryside and polder landscapes",
      "Take pictures with traditional windmills in Zaanse Schans"
    ],
    basicInfo: {
      "Destination": "Netherlands",
      "Entry Point": "Amsterdam Schiphol Airport",
      "Official Language": "Dutch (English widely spoken)",
      "Currency": "Euro (EUR)",
      "Visa Requirement": "Schengen Visa required for most non-EU countries",
      "Best Travel Time": "April for tulip season and festivals",
      "Travel Group Size": "Ideal for couples, families, and friends",
      "Time Zone": "GMT+2 (CEST in April)"
    },
    included: [
      "Hotel accommodations in Amsterdam and nearby cities",
      "Daily breakfast and select dinners",
      "Keukenhof Gardens entry and guided tour",
      "City canal cruise tickets",
      "King’s Day city celebration guide",
      "Museum pass (Van Gogh or Rijksmuseum)",
      "Train tickets for day trips to historic towns"
    ],
    tips: [
      "Wear layers — spring weather can be chilly and rainy.",
      "Book Keukenhof and King’s Day events well in advance.",
      "Use an OV-chipkaart for easy local transport on trams and trains.",
      "Bicycles are everywhere — be alert when walking or crossing.",
      "Try local foods like stroopwafels, herring, and Dutch pancakes.",
      "Museums tend to be crowded in peak season — go early for entry."
    ]
  },  
  {
    id: 16,
    name: "Himachal Pradesh",
    image: "/images/destinations/himachal_pradesh.jpg",
    rating: 4.8,
    days: 7,
    categories: ["Mountains", "Winter Activities","Landscape"],
    months: ["April", "December"],
    title: "Breathe the Mountain Air, Live the Himachal Dream",
    description: `
      Himachal Pradesh, nestled in the majestic Himalayas, is a serene haven for nature lovers, thrill seekers, and spiritual wanderers alike. With snow-capped peaks, lush valleys, glacial rivers, and charming hill towns, the region offers an unforgettable blend of adventure and tranquility.
  
      From the colonial charm of Shimla and the spiritual calm of Dharamshala to the adventure capital of Manali and the apple orchards of Kinnaur, every corner of Himachal Pradesh has a unique story. Whether you want to ski in Solang Valley, trek to Triund, or simply sip chai overlooking misty mountains, this is the ultimate Himalayan escape.
    `,
    highlights: [
      "Explore colonial-era architecture in Shimla",
      "Trek the scenic trails of Triund and Hampta Pass",
      "Try river rafting in Kullu or paragliding in Bir Billing",
      "Experience Tibetan culture in McLeod Ganj",
      "Ski or snowboard in Solang Valley during winter",
      "Soak in natural hot springs at Manikaran",
      "Wander through apple orchards in Spiti and Kinnaur",
      "Capture postcard views of snow-clad peaks and terraced valleys"
    ],
    gallery: [
      "/country/HimachalPradesh/himachal1.jpg",
      "/country/HimachalPradesh/himachal2.jpg",
      "/country/HimachalPradesh/himachal3.jpg",
      "/country/HimachalPradesh/himachal4.jpg",
      "/country/HimachalPradesh/himachal5.jpg",
      "/country/HimachalPradesh/himachal6.jpg",
      "/country/HimachalPradesh/himachal7.jpg",
      "/country/HimachalPradesh/himachal8.jpg",
      "/country/HimachalPradesh/himachal9.jpg",
      "/country/HimachalPradesh/himachal10.jpg",
    ],
    basicInfo: {
      "Destination": "Himachal Pradesh, India",
      "Entry Point": "Chandigarh / Delhi (via road or domestic flight)",
      "Official Language": "Hindi (English widely spoken)",
      "Currency": "Indian Rupee (INR)",
      "Visa Requirement": "E-visa available for foreign nationals",
      "Best Travel Time": "March to June for pleasant weather, December for snow",
      "Travel Group Size": "Flexible for solo, couples, or groups",
      "Time Zone": "GMT+5:30 (IST)"
    },
    included: [
      "3-star and 4-star hotel accommodations",
      "Daily breakfast and dinner",
      "Local sightseeing in AC vehicle",
      "Himalayan nature walk or guided trek (optional)",
      "Entry passes for major attractions",
      "Dedicated driver and trip coordinator"
    ],
    tips: [
      "Carry warm clothes even in summer for high-altitude areas",
      "Book vehicles early during peak tourist season",
      "Avoid plastic — Himachal enforces strict eco-rules",
      "Try local foods like siddu and momos",
      "Always check road conditions during winter travel"
    ]
  },  
  {
    id: 17,
    name: "Leh Ladakh",
    image: "/images/destinations/leh_ladakh.jpg",
    rating: 4.8,
    days: 7,
    categories: ["Mountains","Adventure"],
    months: ["May"],
    title: "Conquer the Roof of India—Discover Leh Ladakh",
    description: `
      Leh Ladakh is not just a destination—it's a soul-stirring journey through the heart of the Himalayas. Known for its surreal landscapes, ancient monasteries, and dramatic mountain passes, this high-altitude desert attracts adventurers, bikers, and seekers of peace alike.
  
      From the iconic Pangong Lake to the mighty Khardung La Pass, Leh Ladakh offers vistas that defy imagination. The crisp air, vibrant prayer flags fluttering against stark cliffs, and encounters with local Tibetan culture make every moment unforgettable. Whether you're biking through rugged terrain or meditating in a monastery, Ladakh invites you to slow down and absorb its raw beauty.
    `,
    highlights: [
      "Drive across the legendary Khardung La—one of the world’s highest motorable roads",
      "Marvel at the turquoise waters of Pangong Tso Lake",
      "Visit Thiksey, Hemis, and Diskit monasteries rich in Buddhist heritage",
      "Experience the magnetic hill where gravity seems to reverse",
      "Camp under the stars in Nubra Valley’s sand dunes",
      "Ride a double-humped Bactrian camel in Hunder",
      "Cross the mesmerizing Chang La and Zojila mountain passes",
      "Witness traditional Ladakhi architecture and festivals"
    ],
    gallery: [
      "/country/LehLadakh/leh1.jpg",
      "/country/LehLadakh/leh2.jpg",
      "/country/LehLadakh/leh3.jpg",
      "/country/LehLadakh/leh4.jpg",
      "/country/LehLadakh/leh5.jpg",
      "/country/LehLadakh/leh6.jpg",
      "/country/LehLadakh/leh7.jpg",
      "/country/LehLadakh/leh8.jpg",
      "/country/LehLadakh/leh9.jpg",
      "/country/LehLadakh/leh10.jpg",
      "/country/LehLadakh/leh11.jpg",
    ],
    basicInfo: {
      "Destination": "Leh Ladakh, India",
      "Entry Point": "Leh Kushok Bakula Rimpochee Airport",
      "Official Language": "Ladakhi, Hindi, English",
      "Currency": "Indian Rupee (INR)",
      "Visa Requirement": "No visa for Indian nationals; Protected Area Permit for certain zones",
      "Best Travel Time": "May to September",
      "Travel Group Size": "Small groups (2–8 people) recommended",
      "Time Zone": "GMT+5:30 (IST)"
    },
    included: [
      "Comfortable hotel and tented camp accommodations",
      "Daily breakfast and dinner",
      "Airport transfers and local transport in SUV",
      "Sightseeing with local guide",
      "Permits for restricted areas (Nubra, Pangong, etc.)",
      "First aid and oxygen cylinder for high-altitude support"
    ],
    tips: [
      "Rest for a day after arrival to acclimatize to the altitude",
      "Carry warm clothing even during summer months",
      "Avoid alcohol and heavy meals on the first day",
      "Pack sunscreen, lip balm, and hydration salts",
      "Mobile network is limited—carry cash and inform contacts in advance",
      "Respect local customs and monasteries' silence zones"
    ]
  },  
  {
    id: 18,
    name: "Italy",
    image: "/country/Italy/italy1.jpeg",
    rating: 4.8,
    days: 7,
    categories: ["City Tour", "Landscape", "Historical"],
    months: ["May", "June"],
    title: "Fall in Love with Italy—Art, Romance, and Timeless Beauty Await",
    description: `
      Italy is a dream woven in cobblestone streets, Renaissance art, and golden coastlines. From the ancient ruins of Rome to the romantic canals of Venice, this iconic destination overflows with culture, history, and charm. Whether you're savoring handmade pasta in a Tuscan village or gazing at Michelangelo's masterpieces, Italy immerses you in beauty at every turn.
  
      With rolling vineyards, dramatic seaside cliffs, and fashion-forward cities like Milan, Italy offers something for every traveler. It's a place where every meal is a celebration, every square tells a story, and every sunset feels like a painting. Prepare to be enchanted.
    `,
    highlights: [
      "Throw a coin into the Trevi Fountain in Rome for good luck",
      "Cruise through the canals of Venice on a traditional gondola",
      "Climb the Duomo and admire Florence’s Renaissance skyline",
      "Tour the ruins of Pompeii and Mount Vesuvius",
      "Indulge in wine tasting in the hills of Tuscany",
      "Take postcard-perfect photos in the colorful Cinque Terre",
      "Admire the Amalfi Coast’s dramatic sea cliffs and lemon groves",
      "Feast on pizza in Naples—the dish’s birthplace"
    ],
    gallery: [
      "/country/Italy/italy1.jpeg",
      "/country/Italy/italy2.jpeg",
      "/country/Italy/italy3.jpeg",
      "/country/Italy/italy4.jpeg",
      "/country/Italy/italy5.jpeg",
      "/country/Italy/italy6.jpeg",
      "/country/Italy/italy7.jpeg",
    ],
    basicInfo: {
      "Destination": "Italy",
      "Entry Point": "Rome Fiumicino, Milan Malpensa, or Venice Marco Polo Airport",
      "Official Language": "Italian",
      "Currency": "Euro (€)",
      "Visa Requirement": "Schengen Visa required for non-EU citizens",
      "Best Travel Time": "May to October",
      "Travel Group Size": "Flexible: couples, families, or small groups",
      "Time Zone": "GMT+1 (CET), GMT+2 (CEST during daylight saving)"
    },
    included: [
      "4-star accommodations in major cities and scenic towns",
      "Daily breakfast and select guided tours",
      "Airport transfers and high-speed train connections",
      "Entrance to key historical sites (Colosseum, Vatican, etc.)",
      "Wine tasting or cooking class experience",
      "Local expert guide support"
    ],
    tips: [
      "Book popular attractions like the Vatican and Colosseum in advance",
      "Wear comfortable walking shoes—many streets are cobblestoned",
      "Learn basic Italian phrases; locals appreciate the effort",
      "Keep cash on hand for small purchases in villages",
      "Tipping is appreciated but not mandatory—rounding up is common",
      "Shops often close midday—plan sightseeing around siesta hours"
    ]
  },  
  {
    id: 19,
    name: "London",
    image: "/country/London/london3.jpeg",
    rating: 4.8,
    days: 7,
    categories: ["City Tour", "Adventure"],
    months: ["June", "December"],
    title: "Step Into the Storybook Charm of London—Where Tradition Meets Trend",
    description: `
      London, the majestic capital of the United Kingdom, seamlessly blends rich history with modern flair. From the royal guards at Buckingham Palace to the fashion-forward streets of Soho, this cosmopolitan city offers a vibrant mix of culture, architecture, shopping, and entertainment.
  
      Explore world-class museums, cruise along the Thames, or ride the London Eye for panoramic city views. With iconic landmarks like Big Ben, Tower Bridge, and Westminster Abbey, every corner tells a story. Whether you’re visiting the West End for a theater show or sipping afternoon tea in a charming cafe, London is timeless, stylish, and always unforgettable.
    `,
    highlights: [
      "Watch the Changing of the Guard at Buckingham Palace",
      "Marvel at the Crown Jewels in the Tower of London",
      "Ride the London Eye for sweeping city views",
      "Stroll through Hyde Park or Regent’s Park",
      "Experience the buzz of Piccadilly Circus and Oxford Street shopping",
      "Visit world-renowned museums like the British Museum and Tate Modern",
      "Take a scenic cruise down the River Thames",
      "Enjoy West End musicals and classic British pubs"
    ],
    gallery: [
      "/country/London/london3.jpeg",
      "/country/London/london1.jpeg",
      "/country/London/london2.jpeg",
      
      "/country/London/london4.jpeg",
      "/country/London/london5.jpeg",
    ],
    basicInfo: {
      "Destination": "London, United Kingdom",
      "Entry Point": "Heathrow, Gatwick, or London City Airport",
      "Official Language": "English",
      "Currency": "Pound Sterling (£)",
      "Visa Requirement": "eVisa or visa on arrival for eligible countries",
      "Best Travel Time": "April to June and December for festive lights",
      "Travel Group Size": "Great for solo travelers, couples, and families",
      "Time Zone": "GMT (BST in summer)"
    },
    included: [
      "4-star hotel stay in central London",
      "Daily breakfast and city tour pass",
      "Airport transfers and local transport card (Oyster or Travelcard)",
      "Thames River cruise or London Eye ticket",
      "Guided walking tour or hop-on hop-off bus access",
      "Museum entrance fees for included exhibits"
    ],
    tips: [
      "Carry a contactless card or Oyster card for easy travel on Tube and buses",
      "London weather can change quickly—carry a compact umbrella",
      "Tap water is safe to drink across the city",
      "Tipping in restaurants is appreciated (around 10%) but not compulsory",
      "Book West End show tickets in advance for better seats and pricing",
      "Stay on the right side of escalators—locals walk on the left"
    ]
  },  
  {
    id: 20,
    name: "Iceland",
    image: "/country/Iceland/iceland1.jpeg",
    rating: 4.8,
    days: 7,
    categories: ["Adventure", "Winter Activities"],
    months: ["June"],
    title: "Chase Waterfalls, Glaciers, and the Midnight Sun in Iceland",
    description: `
      Iceland is a land of otherworldly beauty—where nature writes its own poetry in volcanic plains, icy caves, and geothermal lagoons. Known as the Land of Fire and Ice, this Nordic island nation is perfect for thrill-seekers, photographers, and nature lovers alike.
  
      Whether you're hiking through lava fields, bathing in the Blue Lagoon, or marveling at waterfalls crashing through green cliffs, Iceland is raw, real, and breathtaking. In June, the midnight sun adds a surreal glow to the landscape, letting you explore nearly 24 hours a day. Prepare for a true adventure on the edge of the Arctic Circle.
    `,
    highlights: [
      "Relax in the healing waters of the Blue Lagoon",
      "Experience the power of Gullfoss, Skógafoss, and Seljalandsfoss waterfalls",
      "Walk along black sand beaches in Vik",
      "Hike glaciers or explore ice caves near Vatnajökull",
      "Witness geysers erupt at Geysir Hot Springs",
      "Drive the Golden Circle scenic route",
      "Spot puffins, seals, and whales in the wild",
      "Soak in geothermal hot springs under the midnight sun"
    ],
    gallery: [
      "/country/Iceland/iceland1.jpeg",
      "/country/Iceland/iceland2.jpeg",
      "/country/Iceland/iceland3.jpeg",
      "/country/Iceland/iceland4.jpeg",
      "/country/Iceland/iceland5.jpeg",
    ],
    basicInfo: {
      "Destination": "Iceland",
      "Entry Point": "Keflavík International Airport (near Reykjavík)",
      "Official Language": "Icelandic (English widely spoken)",
      "Currency": "Icelandic Króna (ISK)",
      "Visa Requirement": "Schengen visa or visa-free entry for many countries",
      "Best Travel Time": "June to August for mild weather and midnight sun",
      "Travel Group Size": "Ideal for solo travelers, couples, or small groups",
      "Time Zone": "GMT (no daylight savings)"
    },
    included: [
      "Comfort hotel stays or countryside guesthouses",
      "Daily breakfast and select local dinners",
      "Airport transfers and Golden Circle guided tour",
      "Blue Lagoon entry with towel and drink",
      "Glacier walk or geyser stop (based on itinerary)",
      "All internal transport and park entrance fees"
    ],
    tips: [
      "Weather can shift quickly—pack waterproof layers",
      "Tap water is among the cleanest in the world—bring a refillable bottle",
      "Iceland is cashless-friendly; cards are accepted almost everywhere",
      "Always follow trail signs and respect natural landmarks",
      "Rent a 4x4 if you plan to drive into remote areas",
      "Use a power adapter (plug types C and F, 230V)"
    ]
  },  
  {
    id: 21,
    name: "Spain",
    image: "/country/Spain/spain1.jpeg",
    rating: 4.8,
    days: 7,
    categories: ["Adventure", "Beaches"],
    months: ["June", "August"],
    title: "Dance, Dine, and Discover: Your Epic Spanish Escape Awaits",
    description: `
      Spain is a country that pulsates with passion—from its flamenco rhythms to its vibrant street festivals, golden coastlines, and historic cities. Whether you're wandering through the Moorish palaces of Andalusia, sipping sangria by the beach in Barcelona, or diving into the electric energy of La Tomatina or San Fermín, Spain knows how to stir the soul.
  
      With world-class cuisine, rich cultural diversity, and sun-drenched adventures, Spain invites you to explore at your own pace. It's the perfect blend of fiesta and siesta, making it ideal for travelers seeking both excitement and ease.
    `,
    highlights: [
      "Experience the energy of La Tomatina or Running of the Bulls",
      "Explore Gaudí’s architectural masterpieces in Barcelona",
      "Relax on the Mediterranean beaches of Costa Brava",
      "Visit the historic Alhambra palace in Granada",
      "Indulge in tapas, churros, and paella across every region",
      "Enjoy flamenco performances in Seville",
      "Party through the night in Ibiza or Madrid",
      "Take a scenic train ride through northern Spain’s vineyards"
    ],
    gallery: [
      "/country/Spain/spain1.jpeg",
      "/country/Spain/spain2.jpeg",
      "/country/Spain/spain3.jpeg",
      "/country/Spain/spain4.jpeg",
      "/country/Spain/spain5.jpeg",
    ],
    basicInfo: {
      "Destination": "Spain",
      "Entry Point": "Madrid-Barajas or Barcelona El Prat International Airport",
      "Official Language": "Spanish (regional languages also spoken)",
      "Currency": "Euro (EUR)",
      "Visa Requirement": "Schengen visa or visa-free entry for eligible countries",
      "Best Travel Time": "June to August for festivals and beach weather",
      "Travel Group Size": "Great for friend groups or solo backpackers",
      "Time Zone": "GMT+1 (CET)"
    },
    included: [
      "Handpicked 3- or 4-star hotel stays",
      "Daily breakfast and welcome dinner",
      "City walking tours and skip-the-line attraction tickets",
      "Airport pickup and local transport (based on itinerary)",
      "Event access (festival or flamenco night where applicable)",
      "Multilingual travel guide assistance"
    ],
    tips: [
      "Dine late—restaurants usually open for dinner after 8 PM",
      "Learn basic Spanish greetings for a warmer welcome",
      // "Watch for pickpockets in tourist-heavy areas",
      "Book festival accommodations well in advance",
      "Try local regional dishes beyond tapas—like pintxos in Basque country",
      "Public transport is excellent—get a local travel pass for savings"
    ]
  },  
  {
    id: 22,
    name: "East Africa",
    image: "/images/destinations/east_africa.jpg",
    rating: 4.8,
    days: 7,
    categories: ["Wildlife"],
    months: ["July"],
    title: "Witness the Wild: Your Great African Safari Begins Here",
    description: `
      East Africa is the ultimate destination for wildlife lovers and nature enthusiasts. From the thundering wildebeest migration across the Serengeti to the tranquil waters of Lake Victoria and the snow-capped peaks of Mount Kilimanjaro, this region offers a truly raw and breathtaking adventure.
  
      The region spans across iconic countries like Kenya, Tanzania, and Uganda, each with its own national parks, vibrant cultures, and opportunities for unforgettable encounters with Africa’s Big Five. Whether you're tracking gorillas in the misty mountains or watching lions hunt at dawn, East Africa delivers experiences found nowhere else on Earth.
  
      It’s a place where luxury tented camps meet untamed wilderness, and every sunrise brings a new story from the savannah.
    `,
    highlights: [
      "Witness the Great Migration in the Serengeti and Masai Mara",
      "Safari drives with close encounters of lions, elephants, and rhinos",
      "Track endangered mountain gorillas in Uganda or Rwanda",
      "Watch flamingos paint Lake Nakuru pink",
      "Visit Maasai villages and experience their traditions",
      "Soak in the views of Mount Kilimanjaro",
      "Relax on the white-sand beaches of Zanzibar post-safari"
    ],
    gallery: [
      "/country/EastAfrica/africa1.jpeg",
      "/country/EastAfrica/africa2.jpeg",
      "/country/EastAfrica/africa3.jpeg",
      "/country/EastAfrica/africa4.jpeg",
      "/country/EastAfrica/africa5.jpeg",
    ],
    basicInfo: {
      "Destination": "East Africa (Kenya, Tanzania, Uganda)",
      "Entry Point": "Jomo Kenyatta (Nairobi) or Kilimanjaro International Airport",
      "Official Language": "Swahili and English widely spoken",
      "Currency": "Varies (Kenyan Shilling, Tanzanian Shilling, Ugandan Shilling)",
      "Visa Requirement": "E-Visa or Visa on Arrival depending on country",
      "Best Travel Time": "June to October (dry season, ideal for safaris)",
      "Travel Group Size": "Small guided groups or private tours",
      "Time Zone": "GMT+3"
    },
    included: [
      "Luxury or mid-range safari lodge accommodations",
      "Daily game drives in 4x4 safari vehicles",
      "Airport transfers and domestic travel within countries",
      "Park entry fees and local ranger/guide support",
      "Select meals (breakfast, lunch, dinner depending on lodge)",
      "Optional cultural village visits or walking safaris"
    ],
    tips: [
      "Bring binoculars and a good zoom lens for wildlife viewing",
      "Pack neutral-colored clothes for game drives",
      "Yellow Fever vaccination may be required",
      "Tipping guides and staff is customary and appreciated",
      "Power may be limited in remote lodges—carry a battery bank",
      "Early mornings and late evenings are best for wildlife sightings"
    ]
  },  
  {
    id: 23,
    name: "Seychelles",
    image: "/images/destinations/seychelles.jpg",
    rating: 4.8,
    days: 7,
    categories: ["Beaches"],
    months: ["July"],
    title: "Escape to Paradise: Discover the Magic of Seychelles",
    description: `
      Seychelles is a dreamlike chain of 115 islands in the Indian Ocean, famed for its powdery white-sand beaches, crystal-clear waters, and lush granite cliffs. It’s where time slows down, the sunsets dazzle, and luxury meets untouched nature.
  
      Whether you're exploring coral reefs, basking under a coconut tree, or enjoying candlelit dinners by the sea, Seychelles promises serenity and sophistication. Its islands—like Mahé, Praslin, and La Digue—offer something for everyone, from nature trails through palm forests to private island resorts for the ultimate escape.
  
      Ideal for couples, honeymooners, or solo travelers seeking tranquility, this tropical oasis delivers barefoot luxury with a wild twist.
    `,
    highlights: [
      "Relax on Anse Lazio and Anse Source d’Argent, among the world’s most beautiful beaches",
      "Snorkel in crystal lagoons filled with vibrant coral and marine life",
      "Visit the UNESCO-listed Vallée de Mai on Praslin Island",
      "Cycle through charming La Digue Island with its laid-back vibe",
      "Spot giant Aldabra tortoises in their natural habitat",
      "Take a scenic helicopter ride over the island chain",
      "Enjoy Creole cuisine and beachside dining at sunset"
    ],
    gallery: [
      "/country/Seychelles/seychelles1.jpeg",
      "/country/Seychelles/seychelles2.jpeg",
      "/country/Seychelles/seychelles3.jpeg",
      "/country/Seychelles/seychelles4.jpeg",
      "/country/Seychelles/seychelles5.jpeg",
    ],
    basicInfo: {
      "Destination": "Seychelles (Mahé, Praslin, La Digue)",
      "Entry Point": "Seychelles International Airport (SEZ), Mahé",
      "Official Language": "Creole, English, and French",
      "Currency": "Seychellois Rupee (SCR)",
      "Visa Requirement": "Visa-free for most nationalities with valid return ticket",
      "Best Travel Time": "April to October (dry season, great for beach and snorkeling)",
      "Travel Group Size": "Ideal for couples, small families, or solo travelers",
      "Time Zone": "GMT+4"
    },
    included: [
      "Luxury beachfront or garden villa stays",
      "Daily breakfast and optional half-board meal plans",
      "Island transfers via ferry or local flights",
      "Snorkeling gear and beach equipment",
      "National park access and guided nature trails",
      "Concierge service and travel assistance"
    ],
    tips: [
      "Sunscreen and mosquito repellent are essentials—pack eco-friendly options",
      "Local SIM cards are affordable and offer good coverage",
      "Tap water is generally safe, but bottled water is preferred by travelers",
      "Keep some cash for smaller islands or markets—ATMs can be sparse",
      "Respect local customs—modesty is appreciated away from the beach",
      "Don’t miss a sunset dinner cruise—it’s a highlight for many visitors"
    ]
  },  
  {
    id: 24,
    name: "Lonavala",
    image: "/images/destinations/lonavala.jpg",
    rating: 4.8,
    days: 3,
    categories: ["Weekend Getaways"],
    months: ["July"],
    title: "Breathe in the Mist: Reconnect with Nature in Lonavala",
    description: `
      Nestled in the Sahyadri hills, Lonavala is a lush green escape just a short drive from Mumbai and Pune. Especially magical during the monsoon season, this hill station transforms into a misty paradise of cascading waterfalls, rolling valleys, and cool breezes.
  
      Perfect for a quick weekend getaway, Lonavala offers a blend of relaxation and exploration—from scenic viewpoints and ancient caves to charming local markets and cozy hillside resorts. It's also known for its iconic chikki and panoramic drives that wind through cloud-covered roads.
  
      Whether you’re hiking to a fort, watching the rain fall over Pawna Lake, or simply enjoying the mist from your balcony, Lonavala is the perfect place to slow down and soak in nature’s serenity.
    `,
    highlights: [
      "Trek to Rajmachi Fort and enjoy the valley views",
      "Experience Bhushi Dam during peak monsoon flow",
      "Explore the ancient Karla and Bhaja Buddhist caves",
      "Watch the clouds roll in from Tiger’s Leap viewpoint",
      "Picnic by Pawna Lake or enjoy lakeside camping",
      "Visit local sweet shops for famous Lonavala chikki",
      "Unwind in a hilltop resort with misty mountain views"
    ],
    gallery: [
      "/country/Lonavala/lonavala5.jpeg",
      "/country/Lonavala/lonavala2.jpeg",
      "/country/Lonavala/lonavala3.jpeg",
      "/country/Lonavala/lonavala1.jpeg",
      "/country/Lonavala/lonavala4.jpeg",
      
    ],
    basicInfo: {
      "Destination": "Lonavala, Maharashtra, India",
      "Entry Point": "Nearest airport: Pune; Nearest railway station: Lonavala Junction",
      "Official Language": "Marathi (Hindi and English widely spoken)",
      "Currency": "Indian Rupee (INR)",
      "Visa Requirement": "No visa required for domestic travelers",
      "Best Travel Time": "July to September (Monsoon season)",
      "Travel Group Size": "Ideal for couples, families, and friend groups",
      "Time Zone": "GMT+5:30 (IST)"
    },
    included: [
      "2-night stay at a hill resort or homestay",
      "Breakfast included with select accommodations",
      "Local sightseeing taxi (optional)",
      "Guided trek options for forts or waterfalls",
      "Evening bonfire (subject to weather)",
      "Rain gear (on request at some hotels)"
    ],
    tips: [
      "Carry waterproof shoes and rain jackets during monsoon",
      "Avoid venturing into overflowing dams or rivers",
      "Weekends get crowded—visit on weekdays for peace",
      "Book stays in advance during peak monsoon weekends",
      "Keep cash handy—card machines may not work in remote areas",
      "Check weather updates before planning treks"
    ]
  },  
  {
    id: 25,
    name: "Mahabaleshwar",
    image: "/images/destinations/mahabaleshwar.jpg",
    rating: 4.8,
    days: 3,
    categories: ["Weekend Getaways"],
    months: ["July"],
    title: "Strawberries, Mist & Mountains: Escape to Mahabaleshwar",
    description: `
      Tucked away in the Western Ghats, Mahabaleshwar is a charming hill station known for its rolling green valleys, mist-covered viewpoints, and juicy strawberries. Come monsoon, the region comes alive with cascading waterfalls, cool breezes, and dramatic vistas over lush valleys.
  
      It's an ideal retreat for nature lovers, families, and couples seeking a peaceful break. The winding forest roads, British-era architecture, and sprawling plantations offer both nostalgia and serenity. From boating at Venna Lake to exploring scenic points like Arthur’s Seat, Mahabaleshwar delivers an immersive blend of relaxation and adventure.
  
      Don’t miss the fresh strawberry cream at local farms or a quiet walk through fog-kissed trails—Mahabaleshwar is where you truly disconnect to reconnect.
    `,
    highlights: [
      "Scenic boat ride at Venna Lake",
      "Visit Arthur’s Seat for panoramic valley views",
      "Taste fresh strawberries and cream at Mapro Garden",
      "Explore ancient temples and colonial-era churches",
      "See Lingmala Waterfall in full monsoon glory",
      "Sunset views from Wilson Point or Bombay Point",
      "Shop for local jams, jellies, and fudge"
    ],
    gallery: [
      "/country/Mahableshwar/mahableshwar1.jpg",
      "/country/Mahableshwar/mahableshwar2.jpg",
      "/country/Mahableshwar/mahableshwar3.jpeg",
      "/country/Mahableshwar/mahableshwar4.jpg",
      "/country/Mahableshwar/mahableshwar5.jpg",
    ],
    basicInfo: {
      "Destination": "Mahabaleshwar, Maharashtra, India",
      "Entry Point": "Nearest airport: Pune; Nearest railway station: Wathar (limited service)",
      "Official Language": "Marathi (Hindi and English widely spoken)",
      "Currency": "Indian Rupee (INR)",
      "Visa Requirement": "No visa required for domestic travelers",
      "Best Travel Time": "July to September (Monsoon beauty) or December to February (Strawberry season)",
      "Travel Group Size": "Great for couples, families, and small groups",
      "Time Zone": "GMT+5:30 (IST)"
    },
    included: [
      "2-night stay at a scenic resort or homestay",
      "Breakfast included at most accommodations",
      "Local sightseeing cab options",
      "Entry to viewpoints and Venna Lake boating",
      "Welcome drink or strawberries at select properties"
    ],
    tips: [
      "Carry light woolens—temperatures drop during rain",
      "Monsoon fog can reduce visibility—drive cautiously",
      "Try fresh strawberry cream from roadside stalls",
      "Avoid plastic bags—Mahabaleshwar is eco-sensitive",
      "Book early for weekends and long holidays",
      "Some waterfalls are seasonal—check ahead before visiting"
    ]
  },  
  {
    id: 26,
    name: "Igatpuri",
    image: "/images/destinations/igatpuri.jpg",
    rating: 4.8,
    days: 3,
    categories: ["Weekend Getaways"],
    months: ["July"],
    title: "Recharge in the Rain: Weekend Escape to Igatpuri’s Misty Hills",
    description: `
      Nestled in the Sahyadri Hills, Igatpuri is a serene hill town known for its mist-covered peaks, lush green landscapes, and cascading waterfalls. Just a few hours from Mumbai or Nashik, it’s the perfect monsoon retreat for travelers looking to unwind amidst nature’s tranquility.
  
      With panoramic views, meditation centers, and hidden trekking trails, Igatpuri offers a refreshing change of pace. Whether you're walking through foggy paths, enjoying roadside bhutta (corn), or relaxing at a hillside resort, Igatpuri delivers calm and connection in equal measure.
  
      This lesser-known gem is especially magical during July, when its surroundings are washed in monsoon greens, and every view feels like a postcard.
    `,
    highlights: [
      "Capture the misty panorama from Camel Valley",
      "Visit Bhatsa River Valley for breathtaking monsoon views",
      "Trek to Kalsubai Peak — the highest in Maharashtra",
      "Explore ancient caves like Tringalwadi Fort and Dhammagiri",
      "Enjoy a peaceful stay at nature resorts with valley views",
      "Watch trains snake through tunnels from vantage points",
      "Savor local hot pakoras and tea during the rain"
    ],
    gallery: [
      "/country/Igatpuri/igatpuri1.jpeg",
      "/country/Igatpuri/igatpuri2.jpeg",
      "/country/Igatpuri/igatpuri3.jpg",
    ],
    basicInfo: {
      "Destination": "Igatpuri, Maharashtra, India",
      "Entry Point": "Nearest railway station: Igatpuri; Nearest airport: Nashik or Mumbai",
      "Official Language": "Marathi (Hindi widely spoken)",
      "Currency": "Indian Rupee (INR)",
      "Visa Requirement": "No visa required for domestic travelers",
      "Best Travel Time": "June to September (for monsoon charm), December to February (cool and pleasant)",
      "Travel Group Size": "Ideal for couples, small groups, and solo retreats",
      "Time Zone": "GMT+5:30 (IST)"
    },
    included: [
      "2-night stay at nature resort or homestay",
      "Daily breakfast and welcome beverage",
      "Access to private trekking trails or valley viewpoints",
      "Guided visits to scenic points and forts (optional)",
      "Bonfire or monsoon indoor activities (at select stays)"
    ],
    tips: [
      "Carry rain gear and wear waterproof shoes during monsoon",
      "Mobile network may be limited in remote areas — download offline maps",
      "Book resort stays in advance on weekends",
      "Carry cash — few places accept cards or UPI",
      "Respect silence zones near Dhammagiri Vipassana Center",
      "Avoid driving at night — roads get foggy and slippery"
    ]
  },  
  {
    id: 27,
    name: "Coorg",
    image: "/images/destinations/coorg.jpg",
    rating: 4.8,
    days: 5,
    categories: ["Landscape", "Weekend Getaways"],
    months: ["August"],
    title: "Unwind in Coorg: Where Coffee, Waterfalls & Forests Welcome You",
    description: `
      Coorg, or Kodagu, is a picturesque hill station in Karnataka, famous for its lush coffee plantations, misty hills, and vibrant Kodava culture. In August, monsoon showers breathe life into its forests and waterfalls, turning the region into a verdant retreat.
  
      From the aroma of freshly brewed coffee to the sound of Abbey Falls crashing into the rocks, Coorg offers a sensory escape for nature lovers and serenity seekers. The landscapes are dotted with spice gardens, ancient temples, and colonial-style homestays that make your stay feel personal and peaceful.
  
      Whether you’re sipping a hot cup of filter coffee on a foggy veranda, spotting elephants in the forest, or strolling through aromatic plantations, Coorg offers the kind of soul-soothing experience city life can’t compete with.
    `,
    highlights: [
      "Trek to Raja’s Seat for panoramic valley views",
      "Visit Abbey Falls and Iruppu Falls at their monsoon peak",
      "Stay in cozy coffee estate homestays",
      "Try authentic Kodava cuisine and homemade wines",
      "Tour local coffee and spice plantations",
      "Explore Namdroling Tibetan Monastery in nearby Bylakuppe",
      "Watch elephants at Dubare Elephant Camp"
    ],
    gallery: [
      "/country/Coorg/coorg1.jpg",
      "/country/Coorg/coorg2.jpeg",
      "/country/Coorg/coorg3.jpg",
      "/country/Coorg/coorg4.jpeg",
      "/country/Coorg/coorg5.jpg",
    ],
    basicInfo: {
      "Destination": "Coorg, Karnataka, India",
      "Entry Point": "Nearest major cities: Mysore (3 hrs), Mangalore (4 hrs), Bengaluru (5 hrs)",
      "Official Language": "Kannada (English and Hindi also spoken)",
      "Currency": "Indian Rupee (INR)",
      "Visa Requirement": "No visa required for domestic travelers",
      "Best Travel Time": "June to September (for monsoon), October to February (cooler weather)",
      "Travel Group Size": "Perfect for families, couples, and nature groups",
      "Time Zone": "GMT+5:30 (IST)"
    },
    included: [
      "4-night stay in a plantation homestay or eco-resort",
      "Daily breakfast and evening coffee",
      "Plantation walk or local sightseeing tour",
      "Entry to Abbey Falls and Raja’s Seat",
      "Transportation between Mysore or Mangalore and Coorg"
    ],
    tips: [
      "Carry mosquito repellent and a raincoat during monsoon season",
      "Homestays are the best way to experience Coorg’s culture",
      "Wear good trekking shoes if visiting during rains",
      "Try local delicacies like Pandi curry (for non-vegetarians)",
      "Mobile networks may fluctuate in remote areas"
    ]
  },  
  {
    id: 28,
    name: "Cherrapunji",
    image: "/images/destinations/cherrapunji.jpg",
    rating: 4.8,
    days: 5,
    categories: ["Landscape"],
    months: ["August"],
    title: "Explore Cherrapunji: The Misty Marvel of the Meghalaya Hills",
    description: `
      Cherrapunji, one of the wettest places on Earth, is a hidden gem tucked away in the lush hills of Meghalaya. Famous for its rolling clouds, dramatic waterfalls, and living root bridges, this high-altitude wonder is a monsoon traveler’s dream—especially in August when the landscape bursts with life.
  
      Mist blankets the valleys, rain nourishes the forest, and the sound of flowing water echoes through the green canyons. Every path here feels like a trail through a fairytale. The drive from Shillong to Cherrapunji is breathtaking, and every viewpoint along the way offers dramatic scenery and unfiltered nature.
  
      Whether you're trekking through foggy trails, crossing natural bridges woven from ancient roots, or marveling at the powerful Nohkalikai Falls, Cherrapunji invites you to slow down and breathe in the purity of Meghalaya’s cloud-kissed landscapes.
    `,
    highlights: [
      "Trek to the iconic Double-Decker Living Root Bridge in Nongriat",
      "Witness the grandeur of Nohkalikai Falls – India’s tallest plunge waterfall",
      "Explore Mawsmai and Arwah caves filled with stalactites and fossils",
      "Drive through rolling hills and endless mist from Shillong",
      "Enjoy panoramic views of Bangladesh plains from Eco Park",
      "Walk through orange orchards and local Khasi villages",
      "Experience monsoon magic with thick fog and endless rain"
    ],
    gallery: [
      "/country/Cherrapunji/cherrapunji1.jpeg",
      "/country/Cherrapunji/cherrapunji2.jpeg",
      "/country/Cherrapunji/cherrapunji3.jpeg",
      "/country/Cherrapunji/cherrapunji4.jpeg",
      "/country/Cherrapunji/cherrapunji5.jpeg",
    ],
    basicInfo: {
      "Destination": "Cherrapunji, Meghalaya, India",
      "Entry Point": "Shillong Airport (Umroi) or Guwahati Airport (Assam, 5 hrs drive)",
      "Official Language": "Khasi and English",
      "Currency": "Indian Rupee (INR)",
      "Visa Requirement": "No visa required for Indian citizens",
      "Best Travel Time": "August to October for monsoon lovers; November to February for clear views",
      "Travel Group Size": "Great for trekkers, photographers, and solo explorers",
      "Time Zone": "GMT+5:30 (IST)"
    },
    included: [
      "4-night stay in eco-resorts or scenic homestays",
      "Daily breakfast and dinner",
      "Guided trek to Nongriat’s root bridges",
      "Visit to major waterfalls and caves",
      "Private transportation from Shillong or Guwahati"
    ],
    tips: [
      "Carry waterproof gear and sturdy shoes—rain is almost guaranteed",
      "Plan treks early in the day to avoid afternoon fog",
      "Respect local customs and don’t litter near sacred forests",
      "Mobile signal may be weak in remote villages",
      "Stay hydrated—humid conditions can be deceptive during hikes"
    ]
  },  
  {
    id: 29,
    name: "Greece",
    image: "/images/destinations/greece.jpg",
    rating: 4.8,
    days: 7,
    categories: ["Landscape"],
    months: ["August"],
    title: "Sail into Myth and Sunset – Discover Magical Greece",
    description: `
      Greece is a dream destination where ancient ruins, sun-kissed beaches, and whitewashed villages create an unforgettable travel tapestry. Whether you're walking through history in Athens, sailing to postcard-perfect islands like Santorini and Mykonos, or enjoying beachside parties in Paros, Greece offers a perfect blend of culture and coastal charm.
  
      The landscape is as diverse as its history—towering cliffs plunge into azure seas, while olive groves stretch across serene hills. Indulge in Mediterranean cuisine, dance till dawn in open-air clubs, or find peace in centuries-old monasteries. Greece invites you to explore its soul, where every island tells a story and every sunset paints a memory.
    `,
    highlights: [
      "Watch the sunset from Oia in Santorini",
      "Visit the Acropolis and Parthenon in Athens",
      "Swim in turquoise waters around Zakynthos and Navagio Beach",
      "Party under the stars in Mykonos",
      "Take a boat tour of the Melissani Cave in Kefalonia",
      "Wander the cobbled streets of Rhodes Old Town",
      "Savor fresh Greek salads, seafood, and ouzo",
      "Climb Mount Lycabettus for panoramic city views"
    ],
    gallery: [
      "/country/Greece/greece1.jpg",
      "/country/Greece/greece2.jpg",
      "/country/Greece/greece3.jpg",
      "/country/Greece/greece4.jpg",
      "/country/Greece/greece5.jpg",
      "/country/Greece/greece6.jpg",
    ],
    basicInfo: {
      "Destination": "Greece",
      "Entry Point": "Athens International Airport or island ferries",
      "Official Language": "Greek",
      "Currency": "Euro (EUR)",
      "Visa Requirement": "Schengen visa required for most non-EU visitors",
      "Best Travel Time": "May to October",
      "Travel Group Size": "Great for couples, groups, or solo travelers",
      "Time Zone": "GMT+2"
    },
    included: [
      "Charming boutique hotel stays or seaside villas",
      "Daily breakfast and selected traditional dinners",
      "Airport and port transfers",
      "Ferry rides between major islands (if applicable)",
      "Historical site entrance tickets",
      "Greek cooking or wine-tasting experience"
    ],
    tips: [
      "Pack light and breathable clothing—summers are hot.",
      "Use ferries for scenic and affordable inter-island travel.",
      "Cash is preferred in smaller towns and shops.",
      "Book island accommodations early during peak season.",
      "Tipping is appreciated but not obligatory.",
      "Try local Greek yogurt, souvlaki, and baklava!"
    ]
  },  
  {
    id: 30,
    name: "Morocco",
    image: "/images/destinations/morocco.jpg",
    rating: 4.8,
    days: 7,
    categories: ["Historical"],
    months: ["September"],
    title: "Step into the Sands of Time – Explore Timeless Morocco",
    description: `
      Morocco is a captivating gateway to Africa, where centuries-old traditions meet vibrant colors, fragrant spices, and enchanting architecture. From the bustling souks of Marrakech to the endless golden dunes of the Sahara, Morocco is a land of sensory overload and soul-stirring discovery.
  
      Wander through the blue alleyways of Chefchaouen, get lost in the maze-like medinas of Fes, or sip mint tea while watching the sun set over the Atlas Mountains. With its blend of Arab, Berber, and French influences, Morocco is both a cultural tapestry and a photographer’s paradise. Here, every moment tells a story—etched in mosaic tiles, woven into rugs, and whispered in desert winds.
    `,
    highlights: [
      "Ride camels through the Sahara Desert at sunset",
      "Sleep under the stars in a luxury desert camp",
      "Stroll the vivid blue streets of Chefchaouen",
      "Explore the ancient Medina of Fes",
      "Visit the iconic Koutoubia Mosque in Marrakech",
      "Experience traditional Moroccan hammam and spa",
      "Hike the High Atlas Mountains",
      "Shop handcrafted rugs and pottery in souks"
    ],
    gallery: [
      "/country/Morocco/morocco1.jpeg",
      "/country/Morocco/morocco2.jpeg",
      "/country/Morocco/morocco3.jpeg",
      "/country/Morocco/morocco4.jpeg",
      "/country/Morocco/morocco5.jpeg",
      "/country/Morocco/morocco6.jpeg",
      "/country/Morocco/morocco7.jpeg",
      "/country/Morocco/morocco8.jpeg",
    ],
    basicInfo: {
      "Destination": "Morocco",
      "Entry Point": "Casablanca or Marrakech International Airport",
      "Official Language": "Arabic and Berber (French widely spoken)",
      "Currency": "Moroccan Dirham (MAD)",
      "Visa Requirement": "Visa-free for many countries up to 90 days",
      "Best Travel Time": "March to May and September to November",
      "Travel Group Size": "Perfect for couples, friends, and photographers",
      "Time Zone": "GMT+1"
    },
    included: [
      "Boutique riad or desert camp accommodations",
      "Daily breakfast and selected traditional dinners",
      "Private transfers and guided city tours",
      "Camel safari in the Sahara Desert",
      "Entrance to major heritage sites",
      "Mint tea welcome and cultural experiences"
    ],
    tips: [
      "Dress modestly, especially in rural areas.",
      "Bargaining is expected in local markets.",
      "Try local delicacies like tagine, couscous, and pastilla.",
      "Carry small change for tips and local purchases.",
      "Keep hydrated in desert climates.",
      "Ask before photographing people, especially in souks."
    ]
  },  
  // {
  //   id: 31,
  //   name: "Venice",
  //   image: "/images/destinations/venice.jpg",
  //   rating: 4.8,
  //   days: 7,
  //   categories: ["Historical"],
  //   months: ["September"],
  //   title: "Float Through Romance – Discover the Magic of Venice",
  //   description: `
  //     Venice, the Floating City, is unlike any other destination in the world. Built across more than 100 small islands in the Venetian Lagoon, this iconic city is a celebration of art, romance, and timeless charm. With its winding canals, historic palazzos, and atmospheric alleyways, Venice invites you to slow down and savor every magical moment.
  
  //     From the grandeur of St. Mark’s Basilica to the masked elegance of the Venice Carnival, every detail whispers stories of centuries past. Glide down the Grand Canal on a gondola, marvel at Renaissance masterpieces, and dine on fresh seafood beside the water. Whether you're attending the Venice Film Festival or simply watching the sun reflect off the lagoon, Venice promises a dreamy escape steeped in elegance and wonder.
  //   `,
  //   highlights: [
  //     "Ride a gondola through the picturesque canals",
  //     "Visit the iconic St. Mark’s Basilica and Doge’s Palace",
  //     "Watch a sunset over the Grand Canal from the Rialto Bridge",
  //     "Attend a masquerade during the Venice Carnival or Film Festival",
  //     "Explore glassmaking traditions in Murano and Burano",
  //     "Sample fresh seafood and cicchetti at canal-side eateries",
  //     "Get lost in the romantic alleyways of San Polo and Cannaregio"
  //   ],
  //   gallery: [
  //     "/images/gallery/venice1.jpg",
  //     "/images/gallery/venice2.jpg",
  //     "/images/gallery/venice3.jpg",
  //     "/images/gallery/venice4.jpg"
  //   ],
  //   basicInfo: {
  //     "Destination": "Venice, Italy",
  //     "Entry Point": "Venice Marco Polo Airport (VCE)",
  //     "Official Language": "Italian",
  //     "Currency": "Euro (€)",
  //     "Visa Requirement": "Schengen Visa (if applicable)",
  //     "Best Travel Time": "April to June and September to October",
  //     "Travel Group Size": "Ideal for couples and culture lovers",
  //     "Time Zone": "GMT+1"
  //   },
  //   included: [
  //     "Charming boutique hotel accommodations",
  //     "Daily breakfast with canal views",
  //     "Private gondola ride through main canals",
  //     "Guided walking tour of major landmarks",
  //     "Entrance to Doge’s Palace and St. Mark’s Basilica",
  //     "Island-hopping tour to Murano and Burano",
  //     "Festival tickets (if aligned with travel dates)"
  //   ],
  //   tips: [
  //     "Wear comfortable shoes – you’ll be walking a lot.",
  //     "Buy a vaporetto (water bus) pass for easy travel.",
  //     "Avoid dining in tourist-heavy spots – explore hidden alleys.",
  //     "Cover shoulders when entering churches.",
  //     "Book gondola rides in the evening for a quieter experience.",
  //     "Carry cash for small purchases at local shops and cafés."
  //   ]
  // },  
  {
    id: 32,
    name: "Amritsar",
    image: "/images/destinations/amritsar.jpg",
    rating: 4.8,
    days: 4,
    categories: ["Historical"],
    months: ["September"],
    title: "Experience Devotion and History in the Heart of Punjab",
    description: `
      Amritsar, a city steeped in spirituality and resilience, is the soul of Punjab. Home to the iconic Golden Temple, the city draws visitors from around the globe to witness its unmatched blend of faith, heritage, and patriotism. Walk through bustling bazaars filled with colorful phulkari embroidery, the aroma of Punjabi food, and echoes of history at every turn.
  
      From the serenity of the Harmandir Sahib to the moving tribute at Jallianwala Bagh, Amritsar offers a powerful cultural experience. Don’t miss the electrifying flag ceremony at Wagah Border, a display of national pride and discipline. Whether it’s the taste of langar at the temple or the warmth of the locals, Amritsar leaves an impression on every traveler’s heart.
    `,
    highlights: [
      "Visit the Golden Temple at sunrise and witness the holy rituals",
      "Feel the history at Jallianwala Bagh Memorial",
      "Watch the Beating Retreat ceremony at Wagah Border",
      "Savor authentic Punjabi cuisine at local dhabas",
      "Explore traditional markets like Hall Bazaar and Katra Jaimal Singh",
      "Experience the community service at the langar kitchen",
      "Admire the intricate Sikh architecture and serene atmosphere"
    ],
    gallery: [
      "/country/Amritsar/amritsar1.jpg",
      "/country/Amritsar/amritsar2.jpg",
      "/country/Amritsar/amritsar3.jpg",
      "/country/Amritsar/amritsar4.jpg",
      "/country/Amritsar/amritsar5.jpg",
    ],
    basicInfo: {
      "Destination": "Amritsar, Punjab, India",
      "Entry Point": "Sri Guru Ram Dass Jee International Airport (ATQ)",
      "Official Language": "Punjabi (Hindi and English also widely spoken)",
      "Currency": "Indian Rupee (INR)",
      "Visa Requirement": "eVisa or Tourist Visa for international travelers",
      "Best Travel Time": "October to March for pleasant weather",
      "Travel Group Size": "Ideal for families, solo travelers, and history lovers",
      "Time Zone": "GMT+5:30 (IST)"
    },
    included: [
      "Comfortable hotel accommodations near city center",
      "Guided tour of Golden Temple and Jallianwala Bagh",
      "Round-trip transfers from airport or railway station",
      "Wagah Border visit with entry pass assistance",
      "Daily breakfast and one authentic Punjabi dinner",
      "Cultural walk through local bazaars"
    ],
    tips: [
      "Cover your head when entering the Golden Temple premises.",
      "Footwear must be removed before entering religious sites.",
      "Carry some cash for local shopping and food stalls.",
      "Try Amritsari kulcha and lassi for an authentic food experience.",
      "The Golden Temple complex is open 24/7 — visit during early morning for fewer crowds.",
      "Photography is restricted in some temple areas — follow signs."
    ]
  },  
  {
    id: 33,
    name: "Uttarakhand",
    image: "/images/destinations/valley_of_flowers.jpg",
    rating: 4.8,
    days: 5,
    categories: ["Landscape"],
    months: ["September"],
    title: "Step Into a Living Canvas of Wild Blooms",
    description: `
      Hidden high in the Western Himalayas of Uttarakhand, Valley of Flowers (India) is a UNESCO World Heritage site that bursts into a mesmerizing bloom each monsoon. This alpine valley, blanketed in rare and exotic flowers, offers a once-in-a-lifetime trekking experience through nature’s own botanical garden.
  
      As you hike through mist-kissed trails surrounded by snow-capped peaks and crystal-clear streams, the fragrance and color of over 600 flower species welcome you at every step. It’s not just a destination — it’s a spiritual journey for nature lovers, trekkers, and photographers alike.
  
      With limited access and a short blooming season, Valley of Flowers feels like a hidden secret of India — untouched, unspoiled, and undeniably magical.
    `,
    highlights: [
      "Trek through a carpet of Himalayan wildflowers in full bloom",
      "Spot rare species like the Blue Poppy and Brahma Kamal",
      "Witness cascading waterfalls and meandering streams",
      "Breathe in the untouched mountain air of the Nanda Devi Biosphere",
      "Combine your visit with Hemkund Sahib, a revered Sikh pilgrimage site",
      "Experience a high-altitude valley surrounded by snow-covered peaks"
    ],
    gallery: [
      "/country/Uttarakhand/uttarakhand1.jpeg",
      "/country/Uttarakhand/uttarakhand2.jpeg",
      "/country/Uttarakhand/uttarakhand3.jpg",
      "/country/Uttarakhand/uttarakhand4.jpeg",
      "/country/Uttarakhand/uttarakhand5.jpeg",
      "/country/Uttarakhand/uttarakhand6.jpeg",
    ],
    basicInfo: {
      "Destination": "Valley of Flowers (India)",
      "Entry Point": "Jolly Grant Airport, Dehradun or Haridwar Railway Station",
      "Official Language": "Hindi, Garhwali (English understood)",
      "Currency": "Indian Rupee (INR)",
      "Visa Requirement": "eVisa or Tourist Visa for international travelers",
      "Best Travel Time": "July to September during the blooming season",
      "Travel Group Size": "Best for small trekking groups (2–10 people)",
      "Time Zone": "GMT+5:30 (IST)"
    },
    included: [
      "Accommodation in base camp hotels and mountain guesthouses",
      "Guided trek with permits to Valley of Flowers National Park",
      "All meals during the trek (vegetarian)",
      "Local transportation from base point (Govindghat) to trailhead",
      "Porter/mule support for luggage",
      "First aid and emergency evacuation support"
    ],
    tips: [
      "The trek is moderately difficult — prepare with basic fitness.",
      "Carry a good quality rain jacket and trekking shoes.",
      "No mobile network beyond Govindghat — inform family in advance.",
      "Only limited accommodation is available — book early.",
      "Plastic is banned — bring eco-friendly water bottles and bags.",
      "Altitude acclimatization is essential — plan a buffer day if needed."
    ]
  },  
  {
    id: 34,
    name: "Arunachal Pradesh",
    image: "/images/destinations/ziro_festival.jpg",
    rating: 4.8,
    days: 5,
    categories: ["Landscape"],
    months: ["September"],
    title: "Feel the Pulse of Music in the Eastern Himalayas",
    description: `
      Set against the breathtaking backdrop of Arunachal Pradesh, Ziro Festival (India) is India’s most iconic outdoor music celebration. Held in the lush Ziro Valley, the festival brings together indie bands, tribal culture, and nature in perfect harmony.
  
      Picture four days of soul-stirring music under open skies, surrounded by golden paddy fields and misty hills. From regional folk and fusion to rock, electronic, and experimental sounds — Ziro is a gathering of creativity, community, and conscious living.
  
      More than a music fest, it’s a cultural immersion. Meet the Apatani tribe, enjoy bamboo architecture, and witness an eco-conscious celebration that respects nature as much as it celebrates sound.
    `,
    highlights: [
      "Watch live performances by top indie bands from across India and abroad",
      "Camp amidst paddy fields under star-lit skies",
      "Engage with Apatani tribal culture, food, and crafts",
      "Attend workshops on music, art, and sustainability",
      "Enjoy an alcohol-free, waste-managed festival zone",
      "Capture panoramic views of Ziro Valley’s rolling landscapes"
    ],
    gallery: [
      "/country/ArunachalPradesh/arunachal1.jpeg",
      "/country/ArunachalPradesh/arunachal2.jpeg",
      "/country/ArunachalPradesh/arunachal3.jpg",
      "/country/ArunachalPradesh/arunachal4.jpg",
      "/country/ArunachalPradesh/arunachal5.jpg",
    ],
    basicInfo: {
      "Destination": "Ziro Valley (India)",
      "Entry Point": "Lilabari Airport (Assam) or Naharlagun Railway Station, followed by road travel",
      "Official Language": "Hindi, English, Apatani (local)",
      "Currency": "Indian Rupee (INR)",
      "Visa Requirement": "Indian visa + Inner Line Permit (ILP) for domestic/international travelers",
      "Best Travel Time": "Late September during the festival",
      "Travel Group Size": "Perfect for solo travelers, friends, and cultural enthusiasts",
      "Time Zone": "GMT+5:30 (IST)"
    },
    included: [
      "Festival pass for all four days",
      "Tent accommodation or eco-lodge stay (as booked)",
      "Shuttle service from designated base locations",
      "Access to local food courts and art zones",
      "Cultural walks and community interaction sessions",
      "Basic medical and emergency support"
    ],
    tips: [
      "Book early — passes and accommodations fill up fast.",
      "Carry warm clothes — temperatures drop sharply at night.",
      "Respect local traditions — the Apatani community is deeply rooted in custom.",
      "No alcohol is sold on site — it's a clean and conscious celebration.",
      "Network may be weak — carry cash and offline maps.",
      "Bring reusable water bottles and cutlery — it's a plastic-free zone."
    ]
  },  
  {
    id: 35,
    name: "Mauritius",
    image: "/images/destinations/mauritius.jpg",
    rating: 4.8,
    days: 6,
    categories: ["Beaches"],
    months: ["October"],
    title: "Unwind in Paradise: Your Tropical Escape to Mauritius",
    description: `
      Mauritius is a jewel in the Indian Ocean — a dreamlike island nation blessed with powdery white-sand beaches, crystal-clear lagoons, and lush volcanic landscapes. This island blends the warmth of African culture with French elegance and Indian flavors, creating an experience unlike any other.
  
      Whether you're relaxing on the beaches of Flic en Flac, sailing on a catamaran across turquoise waters, or hiking through the emerald-green Black River Gorges National Park, Mauritius offers both tranquility and adventure in equal measure.
  
      Known for its welcoming locals, luxury resorts, and stunning coral reefs, Mauritius is the ideal destination for honeymooners, beach lovers, and explorers seeking a scenic yet sophisticated retreat.
    `,
    highlights: [
      "Snorkel or dive at Blue Bay Marine Park among colorful coral reefs",
      "Visit the seven-colored earth of Chamarel and its scenic waterfall",
      "Sail on a catamaran to the secluded Île aux Cerfs",
      "Enjoy water sports like parasailing, kayaking, and paddleboarding",
      "Explore Port Louis markets and savor Creole cuisine",
      "Hike through Black River Gorges and see native wildlife",
      "Watch the sunset at Le Morne Brabant, a UNESCO World Heritage site"
    ],
    gallery: [
      "/country/Mauritius/mauritius1.jpg",
      "/country/Mauritius/mauritius2.jpg",
      "/country/Mauritius/mauritius3.jpg",
      "/country/Mauritius/mauritius4.jpg",
      "/country/Mauritius/mauritius5.jpg",
      "/country/Mauritius/mauritius6.jpg",
    ],
    basicInfo: {
      "Destination": "Mauritius",
      "Entry Point": "Sir Seewoosagur Ramgoolam International Airport",
      "Official Language": "English, French, and Mauritian Creole",
      "Currency": "Mauritian Rupee (MUR)",
      "Visa Requirement": "Visa-free or visa-on-arrival for most countries",
      "Best Travel Time": "May to December (dry and cool season)",
      "Travel Group Size": "Ideal for couples, families, and small groups",
      "Time Zone": "GMT+4"
    },
    included: [
      "Stay at beachfront or luxury resort hotels",
      "Daily breakfast and dinner packages",
      "Airport transfers with meet-and-greet service",
      "Full-day catamaran cruise to Île aux Cerfs",
      "Guided island sightseeing tour",
      "Snorkeling gear and select water sport access"
    ],
    tips: [
      "Pack sunscreen, a hat, and light cotton clothing for tropical weather.",
      "Tap water is safe to drink in most hotels, but bottled water is readily available.",
      "Book water activities in advance to secure slots, especially for peak season.",
      "Left-hand driving — familiarize yourself if you plan to rent a car.",
      "Keep cash handy for small shops or rural areas where cards may not be accepted.",
      "Respect local culture when visiting temples — modest clothing is advised."
    ]
  },  
  {
    id: 36,
    name: "Malaysia",
    image: "/images/destinations/malaysia.jpg",
    rating: 4.8,
    days: 6,
    categories: ["Weekend Getaways"],
    months: ["October"],
    title: "Discover Malaysia: From Towering Skyscrapers to Tropical Jungles",
    description: `
      Malaysia is a captivating blend of modern skylines, lush rainforests, and rich cultural diversity. From the towering Petronas Twin Towers in Kuala Lumpur to the serene beaches of Langkawi and the misty highlands of Cameron, the country is a seamless fusion of urban innovation and natural wonder.
  
      Stroll through vibrant night markets, marvel at Islamic architecture, sample mouthwatering Malaysian street food, and venture into the ancient jungles of Borneo. Malaysia is where tradition meets trend, and every corner reveals a new story waiting to be explored.
  
      Ideal for both city lovers and nature seekers, Malaysia is a dynamic destination that offers luxury, adventure, and cultural depth — all in one unforgettable journey.
    `,
    highlights: [
      "Take in panoramic views from the Petronas Twin Towers",
      "Shop and eat your way through Bukit Bintang in Kuala Lumpur",
      "Explore the UNESCO-listed George Town in Penang",
      "Relax on the pristine beaches of Langkawi",
      "Hike through tea plantations in Cameron Highlands",
      "Experience wildlife at Borneo’s Sepilok Orangutan Sanctuary",
      "Visit Batu Caves and marvel at its massive golden statue"
    ],
    gallery: [
      "/country/Malaysia/malaysia1.jpg",
      "/country/Malaysia/malaysia2.jpg",
      "/country/Malaysia/malaysia3.jpg",
      "/country/Malaysia/malaysia4.jpg",
      "/country/Malaysia/malaysia5.jpg",
      "/country/Malaysia/malaysia6.jpg",
    ],
    basicInfo: {
      "Destination": "Malaysia",
      "Entry Point": "Kuala Lumpur International Airport (KLIA)",
      "Official Language": "Malay (Bahasa Malaysia); English widely spoken",
      "Currency": "Malaysian Ringgit (MYR)",
      "Visa Requirement": "Visa-free for many countries up to 90 days",
      "Best Travel Time": "March to October (drier weather in most regions)",
      "Travel Group Size": "Ideal for solo travelers, families, and groups",
      "Time Zone": "GMT+8"
    },
    included: [
      "City hotel and island resort stays",
      "Daily breakfast and local dinner experiences",
      "Airport and inter-city transfers",
      "Guided city tours and nature excursions",
      "Cultural site entrance fees",
      "Cable car ride in Langkawi or Genting Highlands"
    ],
    tips: [
      "Respect local customs — dress modestly in religious areas.",
      "Public transport in cities is convenient and affordable.",
      "Try local dishes like nasi lemak and laksa from street vendors.",
      "Weather can vary between coasts — pack a light raincoat.",
      "Watch out for monkeys in tourist spots — don’t carry visible food.",
      "Bargaining is common in markets, but be polite and reasonable."
    ]
  },  
  {
    id: 37,
    name: "Istanbul",
    image: "/images/destinations/istanbul.jpg",
    rating: 4.8,
    days: 6,
    categories: ["Historical"],
    months: ["October"],
    title: "Step Into Two Worlds: Explore the Historic Charms of Istanbul",
    description: `
      Istanbul, the city where East meets West, is a mesmerizing blend of ancient empires, vibrant markets, and cultural splendor. Straddling Europe and Asia, this Turkish gem invites travelers to wander through grand mosques, Byzantine basilicas, and bustling bazaars.
  
      From the majestic Hagia Sophia and the Blue Mosque to the opulent Topkapi Palace, every stone whispers tales of sultans and empires. Cruise the Bosphorus at sunset, taste the richness of Turkish cuisine, and sip on apple tea in a centuries-old courtyard.
  
      Whether you're exploring underground cisterns or shopping in the Grand Bazaar, Istanbul offers a sensory feast that fuses the exotic with the elegant. It's a city of contrast, history, and unforgettable hospitality.
    `,
    highlights: [
      "Visit the stunning Hagia Sophia and the Blue Mosque",
      "Cruise the Bosphorus between two continents",
      "Explore the underground Basilica Cistern",
      "Shop for spices, carpets, and souvenirs in the Grand Bazaar",
      "Wander through the historic district of Sultanahmet",
      "Relax at a traditional Turkish Hammam (bath)",
      "Savor authentic Turkish delights and kebabs"
    ],
    gallery: [
      "/country/Istanbul/istanbul1.jpg",
      "/country/Istanbul/istanbul2.jpg",
      "/country/Istanbul/istanbul3.jpg",
      "/country/Istanbul/istanbul4.jpg",
      "/country/Istanbul/istanbul5.jpg",
      "/country/Istanbul/istanbul6.jpg",
    ],
    basicInfo: {
      "Destination": "Istanbul, Turkey",
      "Entry Point": "Istanbul Airport (IST)",
      "Official Language": "Turkish (English spoken in tourist areas)",
      "Currency": "Turkish Lira (TRY)",
      "Visa Requirement": "e-Visa available online for many nationalities",
      "Best Travel Time": "April to June & September to October",
      "Travel Group Size": "Flexible — suitable for solo, couples, and small groups",
      "Time Zone": "GMT+3"
    },
    included: [
      "Heritage hotel accommodations",
      "Daily Turkish breakfast and select local meals",
      "Bosphorus cruise ticket",
      "Guided tours of historical landmarks",
      "Airport transfers and internal transport",
      "Entry to museums and palaces listed in the itinerary"
    ],
    tips: [
      "Dress modestly when visiting mosques — carry a scarf if needed.",
      "Avoid taxis without meters — prefer apps like BiTaksi or Uber.",
      "Learn basic Turkish phrases for easier interactions.",
      "Try Turkish tea or coffee in traditional cafes.",
      "Be prepared for crowds in bazaars — keep valuables secure.",
      "Some attractions are closed on Mondays — plan accordingly."
    ]
  },  
  {
    id: 38,
    name: "Agra",
    image: "/images/destinations/taj_mahal.jpg",
    rating: 4.8,
    days: 1,
    categories: ["Historical"],
    months: ["October"],
    title: "Witness Eternal Love and Mughal Grandeur in Agra",
    description: `
      Agra, the city that cradles the iconic Taj Mahal, stands as a majestic testament to India's rich Mughal heritage. A must-visit for travelers seeking history, romance, and architectural brilliance, Agra offers more than just its world-famous marble mausoleum.
  
      Explore the red sandstone beauty of Agra Fort, stroll through the romantic Mehtab Bagh gardens, and discover the lesser-known gems like Itmad-ud-Daulah’s Tomb — often called the Baby Taj. As you walk the old lanes, you'll experience the fusion of Mughal opulence and local culture.
  
      Whether you're on a quick day trip or a deeper exploration of North India’s Golden Triangle, Agra promises breathtaking sights and timeless memories.
    `,
    highlights: [
      "Marvel at the world wonder — Taj Mahal at sunrise",
      "Visit Agra Fort, a UNESCO World Heritage site",
      "Experience local crafts like marble inlay work and leather goods",
      "Take stunning sunset views from Mehtab Bagh across the Yamuna",
      "Explore the intricate Tomb of Itmad-ud-Daulah",
      "Sample Mughlai cuisine, especially Agra's famous petha sweet"
    ],
    gallery: [
      "/country/Agra/agra1.jpg",
      "/country/Agra/agra2.jpg",
      "/country/Agra/agra3.jpg",
      "/country/Agra/agra4.jpg",
      "/country/Agra/agra5.jpg",
    ],
    basicInfo: {
      "Destination": "Agra, India",
      "Entry Point": "Agra Railway Station / Kheria Airport (AGR)",
      "Official Language": "Hindi (English widely spoken)",
      "Currency": "Indian Rupee (INR)",
      "Visa Requirement": "Indian e-Visa required for most foreign nationals",
      "Best Travel Time": "October to March (cool and pleasant weather)",
      "Travel Group Size": "Ideal for day trips or small groups",
      "Time Zone": "GMT+5:30"
    },
    included: [
      "Entry tickets to Taj Mahal and Agra Fort",
      "Guided heritage walking tour",
      "Private transport within the city",
      "Local lunch with Mughlai flavors",
      "Bottled water and snacks",
      "Hotel pickup and drop (if part of package)"
    ],
    tips: [
      "Taj Mahal is closed on Fridays — plan accordingly.",
      "Footwear is not allowed inside the main mausoleum.",
      "Hire a certified guide to avoid tourist scams.",
      "Early morning visits offer fewer crowds and better photos.",
      "Respect monument preservation rules — avoid touching artwork.",
      "Combine with Fatehpur Sikri or Mathura for a full-day experience."
    ]
  },  
  {
    id: 39,
    name: "Kerala",
    image: "/images/destinations/kerala.jpg",
    rating: 4.8,
    days: 6,
    categories: ["Landscape"],
    months: ["November"],
    title: "Sail Through Serenity and Green Wonders in Kerala",
    description: `
      Known as "God's Own Country", Kerala is a lush paradise tucked away in the southwestern coast of India. With its tranquil backwaters, rolling tea plantations, and golden beaches, Kerala offers an enchanting escape into nature, culture, and wellness.
  
      Float on a houseboat in Alleppey as palm trees sway along the canals. Wander through spice gardens and misty hills in Munnar. Discover the rich traditions of Kathakali performances and ancient Ayurvedic healing. From exotic wildlife in Thekkady to colonial charm in Fort Kochi, every corner of Kerala pulses with authenticity and warmth.
  
      Kerala is not just a destination — it's a rejuvenating experience where time slows, hearts open, and the senses come alive.
    `,
    highlights: [
      "Cruise the tranquil backwaters of Alleppey in a private houseboat",
      "Explore tea plantations and waterfalls in the hills of Munnar",
      "Witness vibrant Kathakali dance and traditional art forms",
      "Relax on the unspoiled beaches of Varkala and Kovalam",
      "Visit Periyar Wildlife Sanctuary and spice plantations in Thekkady",
      "Enjoy authentic South Indian cuisine and fresh seafood"
    ],
    gallery: [
      "/country/Kerala/kerala1.jpg",
      "/country/Kerala/kerala2.jpg",
      "/country/Kerala/kerala3.jpg",
      "/country/Kerala/kerala4.jpg",
      "/country/Kerala/kerala5.jpg",
    ],
    basicInfo: {
      "Destination": "Kerala, India",
      "Entry Point": "Cochin International Airport / Trivandrum International Airport",
      "Official Language": "Malayalam (English widely spoken)",
      "Currency": "Indian Rupee (INR)",
      "Visa Requirement": "Indian e-Visa required for most foreign nationals",
      "Best Travel Time": "October to March (post-monsoon and winter)",
      "Travel Group Size": "Ideal for families, couples, or wellness retreats",
      "Time Zone": "GMT+5:30"
    },
    included: [
      "Accommodation in eco-resorts and heritage homestays",
      "Daily breakfast and local meals",
      "Private transportation with driver",
      "Houseboat day or overnight cruise",
      "Ayurvedic spa or massage session",
      "Cultural performance evening (Kathakali or Mohiniyattam)"
    ],
    tips: [
      "Carry mosquito repellent and light cotton clothing.",
      "Avoid drinking tap water — opt for bottled water.",
      "Book your houseboat cruise in advance during peak season.",
      "Embrace local etiquette — dress modestly in temples and villages.",
      "Try an Ayurvedic consultation for a personalized wellness experience.",
      "Plan some downtime — Kerala is best enjoyed slowly."
    ]
  },  
  {
    id: 40,
    name: "Darjeeling",
    image: "/images/destinations/darjeeling.jpg",
    rating: 4.8,
    days: 5,
    categories: ["Landscape"],
    months: ["November"],
    title: "Unwind in the Queen of the Hills – Discover Darjeeling",
    description: `
      Nestled in the foothills of the eastern Himalayas, Darjeeling is a charming hill station renowned for its panoramic mountain views, colonial-era architecture, and world-famous tea estates. With the majestic Kanchenjunga towering in the distance, this misty retreat offers a unique blend of nature, culture, and calm.
  
      Ride the iconic Darjeeling Himalayan Railway — a UNESCO World Heritage Site — as it winds through lush hillsides and vibrant villages. Explore Buddhist monasteries, stroll through sprawling tea gardens, and enjoy cool mountain air with the scent of camellias. Whether you seek quiet sunrises, local heritage, or scenic treks, Darjeeling wraps it all in a cozy, nostalgic charm.
  
      A favorite for honeymooners and nature lovers, Darjeeling is your gateway to Himalayan tranquility.
    `,
    highlights: [
      "Ride the Darjeeling Himalayan Railway through mountain curves and valleys",
      "Watch the sunrise over Kanchenjunga from Tiger Hill",
      "Tour lush tea estates and learn about tea processing",
      "Visit the Peace Pagoda and Buddhist monasteries",
      "Stroll through Mall Road and explore colonial architecture",
      "Enjoy ropeway views of tea gardens and river valleys"
    ],
    gallery: [
      "/country/Darjeeling/darjeeling1.jpg",
      "/country/Darjeeling/darjeeling2.jpg",
      "/country/Darjeeling/darjeeling3.jpg",
      "/country/Darjeeling/darjeeling4.jpeg",
      "/country/Darjeeling/darjeeling5.jpeg",
      "/country/Darjeeling/darjeeling6.jpeg",
    ],
    basicInfo: {
      "Destination": "Darjeeling, India",
      "Entry Point": "Bagdogra Airport or New Jalpaiguri Railway Station",
      "Official Language": "Nepali, Bengali, Hindi (English spoken in tourist areas)",
      "Currency": "Indian Rupee (INR)",
      "Visa Requirement": "Indian visa or e-Visa required for foreign nationals",
      "Best Travel Time": "October to March (clear views and cool weather)",
      "Travel Group Size": "Ideal for couples, families, and photography enthusiasts",
      "Time Zone": "GMT+5:30"
    },
    included: [
      "Stay in heritage hotels or mountain-view resorts",
      "Daily breakfast and evening tea",
      "Guided sightseeing and entrance fees",
      "Toy train ride tickets (subject to availability)",
      "Private transfers and local transport",
      "All applicable taxes and service charges"
    ],
    tips: [
      "Wake early for clear views of Kanchenjunga before clouds set in.",
      "Layer your clothing — mornings and evenings are chilly.",
      "Try local momos and thukpa at mountain cafes.",
      "Respect monastery silence and remove shoes before entering.",
      "Check toy train availability in advance during peak months.",
      "Bring a raincoat or umbrella — weather can change quickly."
    ]
  },  
  {
    id: 41,
    name: "South Africa",
    image: "/images/destinations/south_africa.jpg",
    rating: 4.8,
    days: 7,
    categories: ["Wildlife"],
    months: ["November"],
    title: "Experience the Wild and Wonder of South Africa",
    description: `
      South Africa is a land of dramatic contrasts — where rugged coastlines meet rolling vineyards, bustling cities overlook wildlife-rich plains, and every corner bursts with culture and color. From the majestic Table Mountain in Cape Town to thrilling safaris in Kruger National Park, South Africa blends natural beauty with exhilarating experiences.
  
      Discover golden beaches, vibrant townships, world-class wine routes, and ancient tribal heritage. Take a road trip on the iconic Garden Route, cage dive with great white sharks, or watch elephants roam freely in the wild. Whether you're an adrenaline junkie or a culture explorer, South Africa delivers unforgettable memories with every step.
  
      It's more than just a destination — it's a journey through nature, history, and heart-pounding adventure.
    `,
    highlights: [
      "Take a cable car to the top of Table Mountain for panoramic views of Cape Town",
      "Experience a Big Five safari in Kruger National Park",
      "Walk along the scenic cliffs of the Garden Route",
      "Taste premium wines in Stellenbosch and Franschhoek valleys",
      "Visit Robben Island, where Nelson Mandela was imprisoned",
      "Dive with great white sharks near Gansbaai (if you're brave enough!)",
      "Hike the dramatic landscapes of the Drakensberg Mountains"
    ],
    gallery: [
      "/country/SouthAfrica/south1.jpg",
      "/country/SouthAfrica/south2.jpg",
      "/country/SouthAfrica/south3.jpg",
      "/country/SouthAfrica/south4.jpg",
      "/country/SouthAfrica/south5.jpg",
      "/country/SouthAfrica/south6.jpg",
      "/country/SouthAfrica/south7.jpg",
      "/country/SouthAfrica/south8.jpg",
      "/country/SouthAfrica/south9.jpg",
      "/country/SouthAfrica/south10.jpg",
    ],
    basicInfo: {
      "Destination": "South Africa",
      "Entry Point": "Cape Town International / OR Tambo International (Johannesburg)",
      "Official Language": "11 official languages including English, Afrikaans, and Zulu",
      "Currency": "South African Rand (ZAR)",
      "Visa Requirement": "Visa-free or visa-on-arrival for many countries",
      "Best Travel Time": "October to March (warm weather and wildlife activity)",
      "Travel Group Size": "Flexible — great for couples, families, and solo travelers",
      "Time Zone": "GMT+2"
    },
    included: [
      "3-star to 5-star accommodations with daily breakfast",
      "Private or group guided safaris",
      "Airport transfers and intercity transportation",
      "Entrance fees to national parks and major attractions",
      "Wine tasting experiences in major wine regions",
      "Support from local travel coordinators"
    ],
    tips: [
      "Always check malaria precautions if visiting safari zones.",
      "South Africa uses a Type M plug — bring an adapter.",
      "Tipping is customary in restaurants and for guides.",
      "Keep valuables secure in major urban areas.",
      "Avoid driving at night in remote regions.",
      "Book safaris and wine tours in advance during peak season."
    ]
  },  
  {
    id: 42,
    name: "Rajasthan",
    image: "/images/destinations/rajasthan.jpg",
    rating: 4.8,
    days: 6,
    categories: ["Wildlife","Historical","City Tour"],
    months: ["December"],
    title: "Uncover the Regal Grandeur of Rajasthan",
    description: `
      Rajasthan is a land where time stands still amidst the opulence of palaces, golden deserts, and timeless traditions. Known as the Land of Kings, this vibrant state in India offers a glimpse into its royal heritage, rich culture, and architectural marvels that span centuries.
  
      From the rose-hued city of Jaipur to the lakes of Udaipur, from the sand dunes of Jaisalmer to the blue alleys of Jodhpur — every city in Rajasthan tells a different story. Experience camel safaris, witness folk dances under starlit skies, and shop for colorful textiles, handcrafted jewelry, and traditional art in bustling bazaars.
  
      Rajasthan invites travelers to lose themselves in its grandeur, charm, and warm hospitality, making every moment feel like a royal chapter in a timeless tale.
    `,
    highlights: [
      "Visit the majestic Amber Fort and City Palace in Jaipur",
      "Explore Udaipur’s serene lakes and royal palaces",
      "Ride camels through the golden dunes of Jaisalmer",
      "Admire the blue-washed cityscape of Jodhpur from Mehrangarh Fort",
      "Experience traditional Rajasthani folk music and dance",
      "Witness the grandeur of ancient temples and havelis",
      "Shop in vibrant markets filled with textiles, pottery, and gems"
    ],
    gallery: [
      "/country/Rajasthan/rajasthan1.jpg",
      "/country/Rajasthan/rajasthan2.jpg",
      "/country/Rajasthan/rajasthan3.jpg",
      "/country/Rajasthan/rajasthan4.jpg",
      "/country/Rajasthan/rajasthan5.jpg",
      "/country/Rajasthan/rajasthan6.jpg",
      "/country/Rajasthan/rajasthan7.jpg",
    ],
    basicInfo: {
      "Destination": "Rajasthan, India",
      "Entry Point": "Jaipur International Airport / Udaipur Airport",
      "Official Language": "Hindi and Rajasthani (English widely spoken)",
      "Currency": "Indian Rupee (INR)",
      "Visa Requirement": "e-Visa or tourist visa required for most foreigners",
      "Best Travel Time": "October to March (pleasant winter climate)",
      "Travel Group Size": "Ideal for small to medium groups or private heritage tours",
      "Time Zone": "GMT+5:30"
    },
    included: [
      "Stay at heritage hotels and royal palaces",
      "Guided city tours with local historians",
      "Private transportation with driver",
      "Evening folk performances with dinner",
      "Entrance fees to monuments and forts",
      "Complimentary camel ride or boat ride (based on city)"
    ],
    tips: [
      "Dress modestly when visiting religious or royal sites.",
      "Carry cash for rural areas where card payments may not work.",
      "Avoid summer months due to extreme heat.",
      "Try authentic Rajasthani dishes like Dal Baati Churma and Laal Maas.",
      "Book palace stays well in advance during the high season.",
      "Respect local customs — especially during village visits or cultural shows."
    ]
  },  
  {
    id: 43,
    name: "Gujarat",
    image: "/images/destinations/gujarat.jpg",
    rating: 4.8,
    days: 6,
    categories: ["Wildlife"],
    months: ["December"],
    title: "Celebrate Culture and Colors in the Heart of Gujarat",
    description: `
      Gujarat is a vibrant blend of tradition, heritage, and natural beauty. From ancient temples and white desert landscapes to dynamic cities and colorful festivals, this western Indian state offers an immersive cultural experience. Whether you're exploring the Gir Forest, marveling at the Statue of Unity, or dancing during Navratri, Gujarat leaves an indelible impression.
  
      With a coastline stretching over 1,600 km, Gujarat is dotted with serene beaches and historic ports. It is also the only home of the Asiatic lion, making wildlife safaris in Sasan Gir a rare treat. The architectural marvels of Modhera Sun Temple, Rani ki Vav, and Champaner add a rich historical layer to every journey.
  
      Known for its hospitality, vegetarian cuisine, and thriving crafts, Gujarat is a land where tradition meets timeless elegance and festive spirit is felt year-round.
    `,
    highlights: [
      "Witness the grandeur of the Rann Utsav in the White Desert of Kutch",
      "Take a jungle safari in Gir National Park to spot Asiatic lions",
      "Visit the world’s tallest statue — Statue of Unity at Kevadia",
      "Explore stepwells like Rani ki Vav, a UNESCO World Heritage Site",
      "Admire the Modhera Sun Temple’s intricate carvings",
      "Enjoy the vibrant Garba and Dandiya Raas during Navratri",
      "Shop for Bandhani textiles, Patola sarees, and handcrafted ornaments"
    ],
    gallery: [
      "/country/Gujarat/gujarat1.jpg",
      "/country/Gujarat/gujarat2.jpeg",
      "/country/Gujarat/gujarat3.jpg",
      "/country/Gujarat/gujarat4.jpg",
      "/country/Gujarat/gujarat5.png",
    ],
    basicInfo: {
      "Destination": "Gujarat, India",
      "Entry Point": "Ahmedabad International Airport / Vadodara Airport",
      "Official Language": "Gujarati and Hindi (English widely understood)",
      "Currency": "Indian Rupee (INR)",
      "Visa Requirement": "e-Visa or tourist visa required for most foreigners",
      "Best Travel Time": "November to February (ideal for festivals and sightseeing)",
      "Travel Group Size": "Flexible for couples, families, and cultural tour groups",
      "Time Zone": "GMT+5:30"
    },
    included: [
      "Comfortable hotel stays in major cities and cultural hubs",
      "Daily breakfast and one regional dinner experience",
      "Private guided tours to historical and wildlife sites",
      "Transport by air-conditioned vehicle",
      "Entry passes for cultural events and monuments",
      "Assistance with local shopping and sightseeing"
    ],
    tips: [
      "Plan in advance if visiting during Rann Utsav or Navratri — accommodations fill quickly.",
      "Respect cultural customs when visiting temples or tribal villages.",
      "Try local snacks like Dhokla, Khandvi, and Fafda with chai.",
      "Winter nights in the desert can be cold — carry warm clothing.",
      "Keep cash handy for rural or local markets where digital payments may not work."
    ]
  },  
  {
    id: 44,
    name: "Finland",
    image: "/images/destinations/finland.jpg",
    rating: 4.8,
    days: 7,
    categories: ["Winter Activities"],
    months: ["December"],
    title: "Experience a Magical Winter Wonderland in Finland",
    description: `
      Finland transforms into an enchanting snow-covered paradise during winter. Renowned for its Northern Lights, frozen lakes, and cozy log cabins, this Nordic country offers a serene yet thrilling escape for travelers. December is the perfect time to visit Santa Claus Village in Rovaniemi, glide through snow-laden forests on a reindeer sleigh, or take a dip in an icy lake after a traditional Finnish sauna.
  
      The natural beauty of Finland is matched by its minimalist design, warm hospitality, and a deep connection to nature. Whether you're chasing the Aurora Borealis, staying in a glass igloo, or dog sledding through Lapland, every experience here feels like a page from a fairy tale.
  
      With long nights, hushed forests, and flickering skies, Finland in December is not just a holiday — it’s a magical memory in the making.
    `,
    highlights: [
      "Witness the spectacular Northern Lights in Lapland",
      "Meet Santa Claus in his official village in Rovaniemi",
      "Stay in a glass igloo under a starlit Arctic sky",
      "Go dog sledding or reindeer sleigh riding through snowy forests",
      "Relax in a traditional Finnish sauna followed by an icy plunge",
      "Enjoy cross-country skiing and snowmobiling adventures",
      "Explore Helsinki’s festive Christmas markets and design stores"
    ],
    gallery: [
      "/country/Finland/finland1.jpg",
      "/country/Finland/finland2.jpg",
      "/country/Finland/finland3.jpg",
      "/country/Finland/finland4.jpg",
      "/country/Finland/finland5.jpg",
      "/country/Finland/finland6.jpg",
      "/country/Finland/finland7.jpg",
      "/country/Finland/finland8.jpg",
    ],
    basicInfo: {
      "Destination": "Finland (Lapland and Helsinki)",
      "Entry Point": "Helsinki-Vantaa Airport / Rovaniemi Airport",
      "Official Language": "Finnish and Swedish (English widely spoken)",
      "Currency": "Euro (EUR)",
      "Visa Requirement": "Schengen Visa required for most non-EU travelers",
      "Best Travel Time": "December to March (winter experiences)",
      "Travel Group Size": "Ideal for couples, families, or solo winter adventurers",
      "Time Zone": "GMT+2"
    },
    included: [
      "Accommodation in hotels, cabins, or igloos",
      "Daily breakfast and select traditional dinners",
      "Airport transfers and local transport in Lapland",
      "Guided Aurora Borealis hunting tours",
      "Dog sledding or snowmobile excursions",
      "Visits to Santa Claus Village and Arctic Circle crossing certificate"
    ],
    tips: [
      "Dress in multiple thermal layers — temperatures can go below -20°C.",
      "Book igloo stays and Northern Lights tours well in advance.",
      "Daylight is limited — plan activities in the few bright hours.",
      "Use a tripod and long exposure for Northern Lights photography.",
      "Try local delicacies like smoked salmon, reindeer meat, and cloudberries.",
      "Carry snow boots with good grip — paths can be icy and slippery."
    ]
  },  
  {
    id: 45,
    name: "Austria",
    image: "/images/destinations/austria.jpg",
    rating: 4.8,
    days: 7,
    categories: ["Winter Activities"],
    months: ["May"],
    title: "Discover Alpine Beauty and Classical Charm in Austria",
    description: `
      Austria in May is a breathtaking experience of snow-capped peaks meeting blooming valleys. This central European gem is famed for its elegant cities, classical music heritage, charming alpine villages, and pristine nature. From the imperial architecture of Vienna to the Sound of Music trails in Salzburg, every corner of Austria blends history, culture, and scenery seamlessly.
  
      As spring unfolds, the lakes glisten, the mountain pastures turn lush green, and the cafes fill with people enjoying the mild sun. Austria offers a peaceful yet culturally rich holiday, with opportunities for both exploration and relaxation.
  
      Whether you’re strolling through baroque palaces, hiking alpine trails, or cruising on Lake Hallstatt, Austria is a picture-perfect destination that leaves visitors enchanted.
    `,
    highlights: [
      "Stroll through the historic Schönbrunn Palace and gardens in Vienna",
      "Follow the Sound of Music trail in Salzburg",
      "Cruise on the serene waters of Lake Hallstatt",
      "Take a cable car to the top of Dachstein Glacier",
      "Explore alpine villages like Zell am See and Seefeld",
      "Visit Mozart’s birthplace and enjoy live classical concerts",
      "Indulge in Austrian pastries like Sachertorte and apple strudel"
    ],
    gallery: [
      "/country/Austria/austria1.jpg",
      "/country/Austria/austria2.jpg",
      "/country/Austria/austria3.jpg",
      "/country/Austria/austria4.jpg",
      "/country/Austria/austria5.jpg",
      "/country/Austria/austria6.jpg",
    ],
    basicInfo: {
      "Destination": "Austria (Vienna, Salzburg, Hallstatt)",
      "Entry Point": "Vienna International Airport / Salzburg Airport",
      "Official Language": "German (English spoken in tourist areas)",
      "Currency": "Euro (EUR)",
      "Visa Requirement": "Schengen Visa required for most non-EU travelers",
      "Best Travel Time": "May to September for scenic and cultural tours",
      "Travel Group Size": "Ideal for couples, families, and solo travelers",
      "Time Zone": "GMT+2"
    },
    included: [
      "Comfortable hotel stays in major cities and alpine towns",
      "Daily breakfast and local cuisine experiences",
      "Airport and inter-city transfers",
      "Guided city walking tours and museum visits",
      "Scenic lake cruise and mountain cable car ride",
      "Entry to selected cultural landmarks and palaces"
    ],
    tips: [
      "Austria is walkable — bring comfortable shoes for cobblestone streets.",
      "Local trains are efficient — consider a rail pass if visiting multiple cities.",
      "Carry some cash — not all cafes and smaller shops accept cards.",
      "Try tap water — it's among the cleanest in Europe.",
      "Dressing in layers helps as the weather can vary between valleys and mountains.",
      "Take advantage of free concerts in parks and churches during spring."
    ]
  },  
  {
    id: 46,
    name: "Portugal",
    image: "/images/destinations/portugal.jpg",
    rating: 4.8,
    days: 7,
    categories: ["City Tour", "Landscape"],
    months: ["May"],
    title: "Wander Through Coastlines, Culture & Cobblestones in Portugal",
    description: `
      Portugal in May welcomes travelers with sun-drenched days, blooming jacaranda trees, and a warm coastal breeze. This Iberian gem offers a perfect blend of rich history, charming cities, dramatic cliffs, and golden beaches. Whether you're wandering the tiled streets of Lisbon, tasting wine in the Douro Valley, or relaxing by the sea in the Algarve, Portugal is a sensory delight.
  
      Known for its soulful Fado music, azulejo tile art, and delicious seafood, Portugal is both vibrant and deeply soulful. Cities like Porto and Sintra feel like storybook towns, while places like Cascais and Lagos provide a beachside escape.
  
      With spring in full bloom and fewer crowds than summer, May is the ideal time to discover Portugal’s charm at a relaxed pace.
    `,
    highlights: [
      "Ride the iconic Tram 28 through the narrow alleys of Lisbon",
      "Watch the sunset from the cliffs of Cabo da Roca",
      "Explore the fairy-tale palaces of Sintra",
      "Enjoy wine tasting in the scenic Douro Valley",
      "Visit the Livraria Lello bookstore in Porto — said to inspire Harry Potter",
      "Swim in the turquoise waters of the Algarve",
      "Savor pastel de nata fresh from a traditional bakery"
    ],
    gallery: [
      "/country/Portugal/portugal1.jpg",
      "/country/Portugal/portugal2.jpg",
      "/country/Portugal/portugal3.jpg",
      "/country/Portugal/portugal4.jpg",
      "/country/Portugal/portugal5.jpg",
      "/country/Portugal/portugal6.jpg",
      "/country/Portugal/portugal7.jpg",
    ],
    basicInfo: {
      "Destination": "Portugal (Lisbon, Porto, Algarve, Sintra)",
      "Entry Point": "Lisbon Portela Airport / Porto Airport",
      "Official Language": "Portuguese (English widely understood)",
      "Currency": "Euro (EUR)",
      "Visa Requirement": "Schengen Visa required for non-EU travelers",
      "Best Travel Time": "May to October for pleasant weather and coastal activities",
      "Travel Group Size": "Suitable for couples, families, and solo travelers",
      "Time Zone": "GMT+1"
    },
    included: [
      "Handpicked boutique and coastal accommodations",
      "Daily breakfast and a traditional Portuguese dinner",
      "Airport transfers and intercity rail/bus tickets",
      "Guided walking tours in Lisbon and Porto",
      "Entry to castles and wine tasting tours",
      "Fado music experience in Alfama district"
    ],
    tips: [
      "Wear comfortable shoes — cities have lots of hills and cobblestone streets.",
      "Portugal is budget-friendly, but some museums offer free entry on Sundays.",
      "Try traveling by train — scenic and efficient across major cities.",
      "Keep coins handy for trams and small shops.",
      "Tap water is safe to drink throughout the country.",
      "Always carry sun protection — even spring can be quite sunny near the coast."
    ]
  },  
  // {
  //   id: 47,
  //   name: "Turkey",
  //   image: "/images/destinations/turkey.jpg",
  //   rating: 4.8,
  //   days: 7,
  //   categories: ["Historical", "Landscape"],
  //   months: ["April"],
  //   title: "Uncover Timeless Wonders and Breathtaking Views in Turkey",
  //   description: `
  //     Turkey is where continents, cultures, and civilizations converge. In April, spring breathes new life into the country — tulips bloom in Istanbul, ancient ruins bask in soft sunlight, and the weather is ideal for exploration. From the East-meets-West energy of Istanbul to the lunar landscapes of Cappadocia, Turkey is rich in contrasts.
  
  //     Whether you’re floating in a hot air balloon over fairy chimneys, wandering through centuries-old bazaars, or relaxing in a thermal pool in Pamukkale, every moment feels like stepping into history. The cuisine is a feast for the senses — kebabs, baklava, and strong Turkish tea shared with local warmth.
  
  //     Turkey offers an immersive experience of history, nature, and heartfelt hospitality — especially beautiful during the vibrant spring season.
  //   `,
  //   highlights: [
  //     "Cruise along the Bosphorus and admire Istanbul's skyline",
  //     "Take a sunrise hot air balloon ride over Cappadocia",
  //     "Explore the ruins of Ephesus, one of the best-preserved Roman cities",
  //     "Bathe in the thermal terraces of Pamukkale",
  //     "Shop and sip tea in the Grand Bazaar and Spice Market",
  //     "Marvel at the Hagia Sophia and Blue Mosque",
  //     "Walk through the fairy-tale villages of Göreme and Uçhisar"
  //   ],
  //   gallery: [
  //     "/images/gallery/turkey1.jpg",
  //     "/images/gallery/turkey2.jpg",
  //     "/images/gallery/turkey3.jpg",
  //     "/images/gallery/turkey4.jpg"
  //   ],
  //   basicInfo: {
  //     "Destination": "Turkey (Istanbul, Cappadocia, Pamukkale, Ephesus)",
  //     "Entry Point": "Istanbul International Airport",
  //     "Official Language": "Turkish (English understood in tourist areas)",
  //     "Currency": "Turkish Lira (TRY)",
  //     "Visa Requirement": "E-Visa required for most nationalities",
  //     "Best Travel Time": "April to June and September to November",
  //     "Travel Group Size": "Suitable for couples, families, and groups",
  //     "Time Zone": "GMT+3"
  //   },
  //   included: [
  //     "4-star or heritage-style accommodations",
  //     "Daily breakfast and guided local experiences",
  //     "Domestic flight between Istanbul and Cappadocia",
  //     "Private airport and hotel transfers",
  //     "Entry to key monuments and cultural sites",
  //     "Optional hot air balloon experience"
  //   ],
  //   tips: [
  //     "Cover shoulders and knees when entering mosques.",
  //     "Haggling is expected in markets — enjoy the experience.",
  //     "Use local currency for better pricing at bazaars.",
  //     "Avoid tap water — bottled water is preferred.",
  //     "Book hot air balloons in advance — they fill up quickly during spring."
  //   ]
  // },  
  {
    id: 48,
    name: "Andaman & Nicobar Islands",
    image: "/images/destinations/andaman_nicobar.jpg",
    rating: 4.8,
    days: 6,
    categories: ["Beaches", "Adventure"],
    months: ["April"],
    title: "Discover Untouched Shores and Underwater Magic in the Andaman Islands",
    description: `
      Nestled in the Bay of Bengal, the Andaman & Nicobar Islands are a tropical escape blessed with shimmering turquoise waters, powdery white beaches, and untouched coral reefs. April offers the perfect weather to bask in island life, with calm seas ideal for water sports and exploration.
  
      From the vibrant coral gardens of Havelock Island to the serene limestone caves of Baratang, the islands are a blend of natural wonder and rich history. Whether you're swimming with colorful fish, exploring lush mangroves, or relaxing on palm-fringed beaches, the Andamans promise rejuvenation and thrill in equal measure.
  
      A perfect mix of adventure and relaxation, these islands are a dream for honeymooners, divers, and nature lovers alike.
    `,
    highlights: [
      "Scuba dive or snorkel at Havelock’s world-renowned reefs",
      "Walk along the iconic Radhanagar Beach at sunset",
      "Visit the historic Cellular Jail in Port Blair",
      "Speedboat to the limestone caves and mud volcanoes of Baratang",
      "Enjoy a glass-bottom boat ride in North Bay",
      "Swim in the pristine waters of Elephant Beach",
      "Experience bioluminescence during a night kayak tour"
    ],
    gallery: [
      "/country/Andaman/andaman1.jpg",
      "/country/Andaman/andaman2.jpg",
      "/country/Andaman/andaman3.jpg",
      "/country/Andaman/andaman4.jpg",
      "/country/Andaman/andaman5.jpg",
      "/country/Andaman/andaman6.jpg",
      "/country/Andaman/andaman7.jpg",
      "/country/Andaman/andaman8.jpg",
    ],
    basicInfo: {
      "Destination": "Andaman & Nicobar Islands (India)",
      "Entry Point": "Veer Savarkar International Airport, Port Blair",
      "Official Language": "Hindi and English",
      "Currency": "Indian Rupee (INR)",
      "Visa Requirement": "No visa required for Indian citizens; restricted area permit for foreigners",
      "Best Travel Time": "October to May (April is ideal for calm waters)",
      "Travel Group Size": "Best for couples, friends, or small family groups",
      "Time Zone": "GMT+5:30 (IST)"
    },
    included: [
      "Beachside or luxury resort accommodations",
      "Airport and inter-island transfers (by ferry or speedboat)",
      "Breakfast and selected water activities",
      "Entry fees to protected marine and national parks",
      "Local guided sightseeing tours",
      "Snorkeling gear and assistance"
    ],
    tips: [
      "Book ferries and scuba slots in advance, especially during peak months.",
      "Mobile connectivity is limited outside Port Blair — download maps offline.",
      "Respect coral reefs — avoid touching or standing on them.",
      "Carry sunscreen, bug repellent, and light cotton clothing.",
      "Plastic is banned in many parts — bring eco-friendly containers."
    ]
  }  
  
  
];

export default destinations;
